import angular from "angular";
import activityConfig from "emun.activity/activity.config";
import cartAdditionalCustomerInfo from "emun.cart/cart-additional-customer-info";
import cartItemAdditionalInfoPrompt from "emun.cart/cart-item-additional-info";
import cartItemQuickViewPrompt from "emun.cart/cart-item-quick-view-prompt";
import cartItemShipDatePrompt from "emun.cart/cart-item-ship-date";
import CartItem from "emun.cart/cart-item.model";
import cartSelectNotes from "emun.cart/cart-select-notes";
import cartConfig from "emun.cart/cart.config";
import cartItemSelectNotes from "emun.cart/cartitem-select-notes";
import createCartPrompt from "emun.cart/create-cart-prompt";
import DownloadImagesPrompt from "emun.cart/download-cart-images-prompt";
import OrderQuestionsPrompt from "emun.cart/order-questions-prompt";
import OrderDetailsPrompt from "emun.order/order-details-prompt";
import orderConfig from "emun.order/order.config";
import shoppingConfig from "emun.shopping/shopping.config";
import resolve from "ioc/resolve";
import orderBy from "lodash/orderBy";
import ServiceBus from "servicestack/service-bus";
import _ from "underscore";
import actionList from "webmodals/action-list";
import docCookies from "webutils/services/doc-cookies";
import $pageConfig from "webutils/services/page-config";
// import OrderDetailQuickView from "emun.order/quick-view/order-details-quick-view";
import cartItemPicker from "emun.cart/cart-item-picker/cart-item-picker";
import advancedCart from "emun.cart/cart-list-advanced";
import shipOnsUrl from "emun.cart/cart-list.ship-ons.htm";
import PriceCalculatorPrompt from "emun.cart/price-calculator/price-calculator";
import promoProductPicker from "emun.cart/promo-product-picker/promo-product-picker";
import labels from "emun.order/_labels";
import required from "emun.order/_required";
import addMultiOrders from "emun.order/add-multi-orders";
import modifyOrder from "emun.order/modify-order/modify-order";
import orderEditableKit from "emun.order/order-editable-kit";
import orderManualCopy from "emun.order/order-manual-copy";
import orderManualSplit from "emun.order/order-manual-split";
import orderMultiAdd from "emun.order/order-multi-add";
import orderMultiAddOptions from "emun.order/order-multi-add-options";
import PrintOrderOptions from "emun.order/order-print";
import openConfigurator from "emun.products/configurator/product-configurator-prompt";
import RetailerPrompt from "emun.retailer/retailer-prompt";
import Product from "emun.shopping/product.model";
import openQuickView from "emun.shopping/shopping-quick-view";
import $appConfig from "servicestack/config";
import modals from "webmodals/modals";
import orderParseItems from "emun.order/parse-items/order-parse-items";
import orderImportItems from "emun.order/import-items/order-import-items";
import LocationPicker from "emun.cust/locations/picker/location-picker";

export const IS_CRM = (ENV_TAGS || []).indexOf("Crm") >= 0;
const $localStorage = resolve("$localStorage");
const errorSound = new Audio(cartConfig.errorSound || "/sounds/alert.wav");
const successSound = new Audio(
  cartConfig.successSound || "/sounds/success.wav"
);

const cantStartWith = [
  "item",
  "line",
  "pos",
  "design",
  "wish",
  "id",
  "$",
  "_",
  "keywords",
  "shop",
  "query",
  "message",
  "is",
  "load",
  "qty",
];
const cantEq = ["bus"];

export default (
  $rootScope,
  $q,
  $timeout,
  $session,
  $state,
  $location,
  $window,
  notify,
  utils
) => {
  window.ga && ga("require", "ec");

  const bus = new ServiceBus();
  const productMap = {};
  let lockedSkus = {};
  let skuTimeouts = {};
  const cart = {
    shipOnsUrl,
    businessModel: $session.businessModel,
    bus,
    items: [],
    vendorMinimums: [],
    promos: [],
    itemIndex: {},
    positionIndex: {},
    designIndex: {},
    load,
    scheduleLoad: _.debounce(load, cartConfig.scheduleLoadTimeout),
    updateStats,
    calculateTotals,
    createPrompt,
    createCart,
    ensureCart,
    exitOrder,
    addProduct,
    addProductById,
    addItem,
    addMultiItem,
    addMultipleItems,
    addMultiItemOptions,
    multiEdit,
    openAdvancedCart,
    manualSplit,
    copyItem,
    removeItem,
    editItem,
    quickView,
    additionalInfo,
    cartItemShipDate,
    shipDatePrompt,
    additionalCustomerInfo,
    removeCart,
    remove: removeCart,
    clearCart,
    empty: clearCart,
    clear: clearCart,
    renameCart,
    rename: renameCart,
    incrementItem,
    decrementItem,
    // changeOptionsPrompt,
    changeOptions,
    changeQuantity,
    applyPoints,
    reset,
    createOptions,
    applyPaymentTerms,
    applyPaymentMethod,
    applyCVV,
    applyShippingRate,
    applyShippingLocation,
    deleteShippingLocation,
    deletePaymentMethod,
    applyOrderInfo,
    editBilling,
    applyPromo,
    clearPromo,
    applyDiscount,
    selectPromoProducts,
    selectDiscountProduct,
    checkPromos,
    shareCart,
    refreshCart,
    emailCart,
    shareCart,
    showLinesStatus,
    cancelOrder,
    activateOrder,
    checkOffers,
    checkSplits,
    enterItem,
    exportQuickReport,
    addToMultipleOrders,
    exportQuickReportImages,
    showCheckout,
    countJsonArray,
    toggleRushOrderFee,
    print,
    remember,
    multiPrint,
    forget,
    shipOnTotal: (shipOn) =>
      cart.items
        .filter((l) => l.shipOn === shipOn)
        .reduce((a, l) => a + l.extendedTotal, 0),
    priceCalculator,
    zeroPrice,
    goToFirstOrder,
    goToOrder,
    openParser,
    openImport,
    getUniqueShipDates: () => {
      cart.shipDates = _.groupBy(cart.items, ci => `${ci.shipOn}`.substring(0, 10));
      cart.uniqueShipDates = Object.keys(cart.shipDates);
      cart.uniqueShipDates.sort();

      cart.uniqueShipDates.map((s) => {
        cart.shipDates[s].total = 0;
        cart.shipDates[s].forEach(function (obj) {
          cart.shipDates[s].total += obj.extendedTotal;
        });
      });
    },
    // begin: session orders
    ordersInSession: () => $localStorage.orders || [],
    custOrdersInSession: () => cart.config.custOrdersInSession(cart),
    orderCountInSession: () => cart.ordersInSession().length,
    clearAllOrdersInSession: () => {
      cart.sessionOrders = [];
      $localStorage.orders = [];
      cart.reset();
    },
    clearOrdersInSession: (...orderIdsToKeep) => {
      cart.sessionOrders = [];
      //   console.debug("clearOrdersInSession", orderIdsToKeep, cart);
      $localStorage.orders = orderIdsToKeep
        .filter((id) => !!id)
        .map((id) => ({ id }));
      cart.hydrateSessionOrders();
    },
    addOrderToSession: (...orders) => {
      $localStorage.orders = [
        ...cart
          .ordersInSession()
          .filter((o) => o && o.id && !orders.some((oo) => o.id === oo.id)),
        ...orders.map(
          ({
            cartName,
            purchaser = {},
            billingLocation = {},
            vendorId,
            id,
            name = cartName || id,
            companyName = purchaser.companyName,
            customerID = purchaser.id,
            accountType = billingLocation.accountType,
            status,
            vendor = vendorId,
          }) => ({
            id,
            name,
            companyName,
            customerID,
            accountType,
            status,
            vendor,
          })
        ),
      ];
      // console.debug(
      // 	"addOrderToSession",
      // 	[...$localStorage.orders],
      // 	[...orders]
      // );
      // console.debug(
      // 	"OrdersInSession", cart.ordersInSession()
      // );
      return cart.hydrateSessionOrders();
    },
    removeOrderFromSession: (...otr) => {
      const ordersToRemove = otr || [cart.id];
      $localStorage.orders = cart
        .ordersInSession()
        .filter((o) => ordersToRemove.indexOf(o.id) === -1);
      // console.debug("removeOrderFromSession", {
      //   ordersToRemove,
      //   ordersInSession: cart.ordersInSession().map((o) => o.id),
      //   cart,
      // });
      return cart.hydrateSessionOrders();
    },
    keepOnly: (id = cart.id) => {
      $localStorage.orders = cart.ordersInSession().filter((o) => o.id !== id);
      cart.hydrateSessionOrders();
    },
    hydrateSessionOrders: () => {
      $localStorage.$apply();
      if (cart.ordersInSession().length) {
        return bus
        .read("QueryCarts.json?src=hydrateSessionOrders", {
          //fields: "Id,CompanyName,Status,Type,RetailerId,CartName",
          Take: 18,
          IdIn: cart
            .ordersInSession()
            .filter((o) => o && o.id)
            .map((o) => o.id),
        })
        .then((r) => {
          cart.sessionOrders = r.data.results;
          $localStorage.orders = cart
            .ordersInSession()
            .filter((o) => cart.sessionOrders.some((so) => so.id === o.id));
          //   console.debug(
          //     "hydrateSessionOrders",
          //     cart.sessionOrders,
          //     $localStorage.orders
          //   );
        });

      } else return;
    },
    // end: session orders

    errorToastFactory,
    view: (options = {}) =>
      // console.debug("view cart", $state.current.name, $state.current) ||
      cart.isInCrm()
        ? $state.go("orders.detail.lines", { orderId: cart.id, ...options })
        : $state.go("cart"),
    validate: (cartId) =>
      cart.bus.validate("SubmitCart.json", { id: cartId || cart.id }),
    checkout: () => {
      // console.debug("checkout cart", $state.current.name, $state.current) ||
      cart.load(cart.id, cart.token).then(() => {
        if (cartConfig.showUnavailableItemsPrompt) {
          var displayUnavailablePrompt = false;
          const queryProductsParams = {
            op: "HydrateCartProducts",
            CartId: cart.id,
            OnlyCartItems: cart.id,
            CartToken: cart.token,
            IncludeInactive: true,
            Take: cart.items.length || 500,
          };
          cart.bus
            .read("QueryProducts.json", queryProductsParams)
            .then(function (res) {
              res.data.results.forEach(function (obj) {
                if (!obj.isB2B && $session.isRetailer())
                  displayUnavailablePrompt = true;
                if (!obj.isSellable && $session.isRepOrAbove())
                  displayUnavailablePrompt = true;
              });
              if (displayUnavailablePrompt) {
                const unavailableItemsActions = {
                  Review: {
                    icon: "edit",
                    body: "Go back and review order",
                    handler: () => {},
                  },
                  Checkout: {
                    icon: "cart-plus",
                    body: "Continue to checkout",
                    handler: function () {
                      cart.isInCrm()
                        ? $state.go("crm-checkout", {cartId: cart.id})
                        : cart.token && !$session.isAuthenticated ? $state.go("shared-checkout", {cartId: cart.id, token: cart.token}) : $state.go("checkout", {cartId: cart.id});
                    },
                  },
                };
                return actionList({
                  title: "Unavailable Items",
                  body: cartConfig.unavailableItemsPromptMessage,
                  actions: unavailableItemsActions,
                  size: "md",
                }).then((a) => a.handler());
              } else {
                cart.isInCrm()
                  ? $state.go("crm-checkout", {cartId: cart.id})
                  : cart.token && !$session.isAuthenticated ? $state.go("shared-checkout", {cartId: cart.id, token: cart.token}) : $state.go("checkout", {cartId: cart.id});
              }
            });
        } else {
          cart.isInCrm() ? $state.go("crm-checkout", {cartId: cart.id}) : cart.token && !$session.isAuthenticated ? $state.go("shared-checkout", {cartId: cart.id, token: cart.token}) : $state.go("checkout", {cartId: cart.id});
        }
      });
    },
    isInCrm: () =>
      $session.businessModel === "Wholesale" &&
      $location.absUrl().indexOf("context=shop") == -1 &&
      $location.absUrl().indexOf("quick-order-entry") == -1 &&
      $location.absUrl().indexOf("retailers#/retailer") == -1 &&
      $location.absUrl().indexOf("catalogs#/catalog") == -1 &&
      (($state.current.menu &&
        !$state.current.menu.startsWith("shop") &&
        !$state.current.menu.startsWith("retailer")) ||
        $state.current.name === "quick-order" ||
        ["/crm", "/orders"].some(
          (slug) => $location.absUrl().indexOf(slug) > -1
        )),
    edit: () =>
      $state.go("orders.detail", { orderId: cart.id, openedit: true }),
    hasPosition: (position) => !!cart.positionIndex[position],
    hasItem: (productId) => !!cart.itemIndex[productId],
    hasDesign: (designId) => !!cart.designIndex[designId],
    hasOption: (productId, fieldId) =>
      cart.itemIndex[productId] &&
      cart.itemIndex[productId].optionIndex[fieldId],
    firstOption: (productId) =>
      cart.itemIndex[productId] &&
      cart.itemIndex[productId].options &&
      cart.itemIndex[productId].options[0],
    isLoaded: () => cart.id > 0,
    isBusy: () => cart.bus.activeCalls.length > 0,
    // begin: sku locking api
    lockSku(productId) {
      lockedSkus[productId] = new Date();
      $rootScope.$emit("skuLocked", { lockedSkus, productId, cart });
    },
    canLockSku(productId) {
      if (cart.isSkuLocked(productId)) {
        const msg =
          "SKU #" + productId + " is locked as of " + lockedSkus[productId];
        notify.warning(msg, {
          title: productId,
          ttl: 2000,
          disableCountDown: true,
        });
        throw new Error(msg);
      }
      return true;
    },
    tryLockSku(productId) {
      if (cart.canLockSku(productId)) {
        return cart.lockSku(productId);
      }
    },
    unlockSku: (productId) => delete lockedSkus[productId],
    isSkuLocked: (productId) => productId in lockedSkus, // &&
    // lockedSkus[productId] + cartConfig.skuLockTimeout < new Date(),
    // end: sku locking api
    applyGiftCard,
    updateOrderActivity,
    update,
    submit,
    hold,
    cancel,
    approve,
    duplicate,
    prelimCopy,
    copy,
    prelimCopyToLocations,
    copyToLocations,
    selectNotes,
    selectLineNotes,
    split,
    processSplit,
    downloadImagesPrompt,
    orderQuestionsPrompt,
    openQuickView,
    openConfigurator,
    wishlist: [],
    getWishlist,
    removeWishlistItem,
    categoryRestrictions: null,
    checkCategoryRestrictions,
    checkVendorMinimums,
    checkShipDateMinimums,
    checkVolumeMinimums,
    config: cartConfig,
    paypalExpressCheckout: {},
    fundboxCheckout,
    fundboxOptions: {},
    cartTitle: cartConfig.cartTitle,
    requestPayment,
    selfCheckout,
    openModifyOrder,
    loadShowSettings,
    initAudio() {
      if (!cart.$audioInitialized) {
        [errorSound, successSound].forEach((s) => {
          s.load();
          // s.volume = 0;
          // s.play();
          //console.debug("initAudio", s);
        });
        cart.$audioInitialized = new Date();
        document.body.removeEventListener("touchstart", cart.initAudio);
        document.body.removeEventListener("click", cart.initAudio);
      }
    },
    playErrorSound() {
      // cart.initAudio();
      console.debug("BL*** playing error sound", errorSound);
      errorSound.volume = 1;
      errorSound.play();
    },
    playSuccessSound() {
      // cart.initAudio();
      console.debug("BL*** playing success sound", successSound);
      successSound.volume = 1;
      successSound.play();
    },
    checkOrderHistory(promoCode) {
      cart.bus
        .send("OrderedPromoProducts", {
          PromoCode: promoCode,
          RetailerId: cart.retailerId,
        })
        .then(function (res) {
          if (res.data.hasOrdered) {
            modals.alert(
              "Customer has ordered one or more of the reward products before"
            );
          } else {
            modals.alert(
              "Customer has not ordered any of the reward products before"
            );
          }
        });
    },
  };
  document.body.addEventListener("touchstart", cart.initAudio);
  document.body.addEventListener("click", cart.initAudio);

  cart.$pageConfig = $pageConfig;
  if (shoppingConfig.paypalExpressCheckout) {
    cart.paypalExpressOptions = {
      env: shoppingConfig.paypalExpressCheckout.env,
      client: {
        sandbox: shoppingConfig.paypalExpressCheckout.key,
        production: shoppingConfig.paypalExpressCheckout.key,
      },
      payment() {
        var env = this.props.env;
        var client = this.props.client;
        return paypal.rest.payment.create(env, client, {
          transactions: [
            {
              amount: { total: cart.grandTotal, currency: "USD" },
            },
          ],
        });
      },
      commit: true,
      onAuthorize(data, actions) {
        return actions.payment.execute().then(function (payment) {
          cart.paymentMethodTransId = payment.id;
          cart.update("paymentMethodTransId").then(function () {
            cart.submit(cart.id);
          });
        });
      },
    };
  }

  //cart.registerValidationErrorNotification();

  let requestedCartId = $location.search().cartId;
  if (requestedCartId) {
    remember(requestedCartId);
  }

  let _init = () => {
    const id = docCookies.getItem("cartId");
    return id ? cart.load(id) : mergeCarts();
  };
  let deferred = $q.defer();
  cart.$$load = deferred.promise;
  $timeout(
    () =>
      _init()
        .then(deferred.resolve, deferred.reject)
        .catch((error) => {
          console.error("onRejected function called: " + error.message);
        }),
    100
  );

  let authEvent = () => mergeCarts(); //.then(() => cart.getWishlist());

  $rootScope.$on("$onAuthenticated", authEvent);
  $rootScope.$on("$onRegistered", authEvent);
  $rootScope.$on("$onLogout", () => reset());
  $rootScope.$on("cartItemRemoved", () => {
    cart.scheduleLoad();
    if (cart.config.checkShipDateMinimumsBeforeCheckout) {
      cart.checkShipDateMinimums();
    }
  });
  $rootScope.$on("cartItemQuantityChanged", () => {
    cart.scheduleLoad();
    if (cart.config.checkShipDateMinimumsBeforeCheckout) {
      cart.checkShipDateMinimums();
    }
  });
  $rootScope.$on("$stateChangeSuccess", () => clearErrors());
  if (cart.config.checkShipDateMinimumsBeforeCheckout) {
    $rootScope.$on("cartItemAdded", cart.checkShipDateMinimums());
  }
  //$rootScope.$on('sessionTimingOut', (e,args) => cart.items.length !!);
  cart.$$load.then(() => $rootScope.$emit("cartReady", cart));
  cart.shoppingConfig = shoppingConfig;
  cart.orderConfig = orderConfig;
  cart.$appConfig = $appConfig;
  cart.labels = labels;

  return cart;

  function clearErrors() {
    //console.info("State Changed Clear Errors");
    cart.bus.validationErrors = null;
  }

  function multiSubmit(cartIds = [], customFields = {}) {
    const currentMultiCartId = cart.multiCartId;
    let chain = $q.when(cartIds);
    cartIds.forEach((cartId) => {
      chain = chain
        .then(() => cart.load(cartId))
        .then(() => cart.validate(cartId));
    });
    cartIds.forEach((cartId) => {
      chain = chain
        // .then(() => cart.load(cartId))
        .then(() =>
           $q.when(cart.submit(cartId, customFields)).catch(() => cart.load(cartId))
        );
    });
    chain = chain.then(({ multiCartId = currentMultiCartId || "!" } = {}) =>
      bus
        .read(`QueryCarts.json`, {
          multiCartId,
          status: "Cart",
          take: 100,
          orderBy: "VendorId",
          fields: "Id,MulticartId,Status,VendorId",
          op: "CartSubmittedCheckMinimums",
          DontIncludeProducts: true,
        })
        .then(({ data: { results = [], ...others } }) => {
          const [next] = results;
          console.debug("multi-confirmation", {
            next,
            results,
            others,
            cartIds,
          });
          const promise = next ? cart.load(next.id) : cart.reset();
          return promise.then(() =>
            $state.go("multi-confirmation", {
              multiCartId,
              remaining: results.length,
              submittedCartIds: cartIds.join(","),
            })
          );
        })
    );
    return chain;
  }

  function submit(cartId, customFields = {}) {
    if (Array.isArray(cartId)) {
      return multiSubmit(cartId, customFields);
    }
    //console.info("BL*** customfields = " + JSON.stringify(customFields));
    if (
      (cart.isOnDemand || cartConfig.hideAcceptTerms === false) &&
      !cart.acceptTerms &&
      shoppingConfig.requireAcceptTerms
    ) {
      modals.alert(
        shoppingConfig.requireAcceptTermsMessage ||
          "You must agree to terms of service before submitting order"
      );
      return;
    }
    if (cart.shipOn == null && required.shipOn) {
      modals.alert("Ship Date is required");
      return;
    }
    if (cart.cancelOn == null && required.cancelOn) {
      modals.alert("Cancel Date is required");
      return;
    }
    if (
      (shoppingConfig.requireCVV &&
        cart.paymentTerms.isCredit &&
        !cart.paymentMethod.securityCode &&
        cart.paymentMethodTransId !== "REQUEST") ||
      (shoppingConfig.requireCVVNewOnly &&
        cart.paymentTerms.isCredit &&
        !cart.paymentMethod.securityCode &&
        cart.paymentMethodName !== "TOKEN" &&
        cart.paymentMethodTransId !== "REQUEST")
    ) {
      modals.alert("You must enter a valid CVV");
      return;
    }

    if (cart.tokenizationProvider == 'HostedPCI' && cart.paymentTerms.isCredit && cart.paymentMethod.token && cart.paymentMethod.id && !customFields.overrideWarnings) {
      cart.bus.send("HostedPCI/GetGatewayToken", {
        VendorId: cart.vendorId || $session.clientId,
        RetailerId: cart.retailerId,
        Token: cart.paymentMethod.id,
        OrderNumber: cart.id
      }).then(function(gatewayResponse) {
          if (gatewayResponse.data.status == "error") {
            modals
            .confirm("There was an error saving the credit card for this order.  The order will be placed on Review\r\n\r\nError: " + gatewayResponse.data.gatewayResponseStatus)
            .result.then(() => cart.submit(cartId, { overrideWarnings: true }));
            return;
          } else {
            cart.submit(cartId, { overrideWarnings: true });
          }
      });
      return;
    }


    if (
      cart.promos.filter((p) => p.qualified).length > 0 &&
      !cart.promoCode &&
      !cart.promoCode2 &&
      cartConfig.askApplyPromotion &&
      !customFields.overrideWarnings
    ) {
      modals
        .acknowledge({
          title: "Are you sure?",
          list: ["There are qualifying promotions that have not been applied"],
          pledge:
            "I acknowledge the warnings expressed above and wish to proceed with order",
        })
        .result.then((ack) => cart.submit(cartId, { overrideWarnings: true }));
      return;
    }

    if (
      cartConfig.requireShowOrderAppointment &&
      $session.isSalesManagementMode() &&
      cart.orderConfig.showSources.includes(cart.sourceId) &&
      !cart.activityId &&
      cart.activities.length > 1
    ) {
      modals.alert("Please select an appointment");
      return;
    }

    if (
      cartConfig.createUserOnCheckout &&
      cart.purchaser.email &&
      !customFields.skipCreateUser
    ) {
      return cart.bus
        .send("QueryUsers.json?Email=" + cart.purchaser.email)
        .then(function (res) {
          if (!res.data.results.length && !customFields.skipCreateUser) {
            return modals
              .confirm(
                `The email address ${cart.purchaser.email} is not associated with a registered user.  Would you like to create a user account?`
              )
              .result.then(
                function () {
                  cart.bus
                    .send("RegisterUser.json", {
                      autoLogin: false,
                      role: "Retailer",
                      retailerId: cart.retailerId,
                      password: "temporaryPassword",
                      confirmPassword: "temporaryPassword",
                      email: cart.purchaser.email,
                      confirmEmail: cart.purchaser.email,
                      permissions: "AllPermissions",
                    })
                    .then(function () {
                      customFields.skipCreateUser = true;
                      cart.submit(cartId, customFields);
                    });
                },
                function () {
                  customFields.skipCreateUser = true;
                  cart.submit(cartId, customFields);
                }
              );
          } else {
            customFields.skipCreateUser = true;
            cart.submit(cartId, customFields);
          }
        });
    }
    if (
      shoppingConfig.fundboxCheckout &&
      cart.paymentTerms.id === "FUNDBOX" &&
      !cart.paymentMethodTransId
    ) {
      cart.fundboxCheckout();
      return;
    }
    // if (cart.paymentMethodTransId === "REQUEST") {
    //   cart.hold(cart.id, "Credit Card");
    //   return;
    // }
    let request = Object.assign(
      {
        id: cartId || cart.id,
      },
      customFields
    );
    let busy = modals.busy(
      "Processing...",
      "Thank you for your patience as your cart is processed."
    );
    let cartSubmitting = { cart, request, promises: [] };
    $rootScope.$emit("cartSubmitting", cartSubmitting);

    if (cart.printer && $session.isShowroom()) {
      request.printer = cart.printer;
      request.numCopies = cart.numCopies;
      request.printWithImages = cart.printWithImages;
    }
    return $q.all(cartSubmitting.promises).then(() => {
      return bus.send("SubmitCart.json", request).then(
        function (response) {
          let cartSubmitted = response.data;
          docCookies.setItem("campaignId", null);

          if (shoppingConfig.useFaceBookPixel) {
            var fbString = "";
            angular.forEach(cart.items, function (item, index) {
              if (index === cart.items.length - 1) {
                fbString += "'" + item.productId + "'";
              } else {
                fbString += "'" + item.productId + "',";
              }
            });

            try {
              fbq("track", "Purchase", {
                content_ids: [fbString],
                content_type: "product",
                value: cart.grandTotal,
                currency: "USD",
              });
            } catch (err) {}
          }

          cart.bus
            .send("QueryRetailers.json?Id=" + cart.retailerId)
            .then(function (res) {
              var retailer = {};
              if (res.data.results.length) retailer = res.data.results[0];
              if (
                $session.isRepOrAbove() &&
                (cartConfig.askQuestions ||
                  (cartConfig.askQuestionsNewAccount && retailer.isNewAccount))
              ) {
                cart.orderQuestionsPrompt(
                  cartSubmitted.id,
                  cartSubmitted.retailerId
                );
              }
            });
          if ($session.isRepOrAbove() && cartSubmitted.postOrderInstructions) {
            modals.alert(cartSubmitted.postOrderInstructions);
          }

          $rootScope.$emit("cartSubmitted", {
            cart,
            request,
            response,
            cartSubmitted,
          });

          //if successful then clear the order from the localstorage
          cart.removeOrderFromSession(request.id, cartSubmitted.id); // b/c of sync order
          cartSubmitted.orderNumbers = "";
          /* BL took this out 12/16/2020  if order is split automatically during submit don't need orders in session */
          //if (Array.isArray(cartSubmitted.splitOrders)) {
          //	cartSubmitted.orderIds = [];
          //	cartSubmitted.splitOrders.forEach(function (ord) {
          //		cart.addOrderToSession({
          //			id: ord.id,
          //			name: ord.cartName || ord.id,
          //			companyName: ord.purchaser.companyName,
          //			customerID: ord.purchaser.id,
          //			status: cart.status,
          //			type: ord.type,
          //			vendor: ord.vendorId,
          //		});
          //		cartSubmitted.orderIds.push(ord.id);
          //	});
          //	cartSubmitted.orderNumbers = cartSubmitted.orderIds.join(",");
          //}

          busy.close(cartSubmitted);
          const routeParmams = {
            ...$state.fromParams,
            orderId: cartSubmitted.id,
            orderNumber: cartSubmitted.id,
          };
          // console.debug("cart.isInCrm()", cart.isInCrm());
          if (cart.isInCrm()) {
            console.debug("cartSubmitted", {
              ...$state,
              orders: cart.ordersInSession(),
              cartConfig,
              cart,
              cartSubmitted,
              $state,
              routeParmams,
            });
            if (cartConfig.orderConfirmationPage || $session.isShowroom()) {
              cart.reset();
              $state.go("crm-confirmation", { orderNumber: cartSubmitted.id });
            } else if (cartConfig.newOrderOnCheckout) {
              cart.reset();
              cart
                .createPrompt({
                  retailerId: cartSubmitted.cart.retailerId,
                  shippingLocationId: cartSubmitted.cart.shipId,
                })
                .then(() => cart.view());
              $state.transitionTo(
                $state.fromState &&
                  $state.fromState.name.indexOf("cust.details.order") === 0
                  ? "cust.details.order"
                  : "orders",
                routeParmams
              );
            } else if (goToFirstOrder()) {
              console.debug("going to first order", cart.ordersInSession()[0]);
            } else {
              cart.reset();
              $state.transitionTo(
                $state.fromState &&
                  $state.fromState.name.indexOf("cust.details.order") === 0
                  ? "cust.details.order"
                  : "orders",
                routeParmams
              );
            }
          } else {
            if (shoppingConfig.multiCart && cartSubmitted.multiCartId) {
              return; // $state.go("multi-cart", cartSubmitted);
            }
            cart.reset();

            if (Array.isArray(cartSubmitted.splitOrders)) {
              $state.go("split-confirmation", {
                orderNumbers: cartSubmitted.orderNumbers,
              });
            } else {
              $state.go("order-confirmation", {
                orderNumber: cartSubmitted.id,
              });
            }
          }
        },
        function error(res) {
          $pageConfig.goTop();
          busy.close();
          const errors = res.data.responseStatus.errors;
          $rootScope.$emit("cartSubmitFailed", { cart, request, res, errors });
          console.debug("cartSubmitFailed", { cart, request, res, errors });
          if (errors !== undefined && errors.length) {
            const warnings = res.data.responseStatus.errors.filter(
              (e) => e.fieldName === "Warning"
            );
            if (warnings.length > 0 && warnings.length === errors.length) {
              modals
                .acknowledge({
                  title: "Are you sure?",
                  list: warnings.map((e) => e.message),
                  pledge:
                    "I acknowledge the warnings expressed above and wish to proceed with order",
                })
                .result.then((ack) =>
                  cart.submit(request.id, { overrideWarnings: true })
                );
            }
          } else {
            notify.error(res.data.responseStatus.message, {
              title: res.data.responseStatus.errorCode,
              ttl: 5000,
            });
          }
        }
      );
    });
  }

  function goToFirstOrder() {
    if (
      cart.orderCountInSession() > 0 &&
      !cartConfig.disableNextOrderInSession
    ) {
      return $state.transitionTo(
        cart.orderConfig.defaultDetailRoute || "orders.detail",
        {
          orderId: cart.ordersInSession()[0].id,
        }
      );
    }
    return false;
  }

  function goToOrder(id) {
    cart.load(id).then(() => {
      if (cartConfig.switchOrderStayInCatalog) {
        if ($state.current.name.indexOf("catalog") == -1) cart.view();
      } else cart.view();
    });
  }

  function updateOrderActivity(prop, cartId) {
    if (
      prop == "activityId" &&
      cartConfig.orderActivityTypes.filter(
        (type) => type.id === cart.activityId
      ).length > 0
    ) {
      console.info("we need to create a new activity", prop, cart.activityId);
      function round(date, duration, method) {
        return moment(Math[method](+date / +duration) * +duration);
      }

      function getEmunTimezone(tz) {
        var timezones = activityConfig.timezones;
        var momentTimezone = timezones.filter(function (z) {
          return z.id == tz;
        });
        if (momentTimezone.length > 0) {
          return momentTimezone[0].label;
        } else {
          return tz;
        }
      }

      var timezone = moment.tz.guess();
      var date = moment.tz(timezone);
      //console.info("dates", round(date, moment.duration(30, "minutes"), "ceil"), round(date, moment.duration(30, "minutes"), "ceil").add("minutes", 60));
      var activity = {
        scheduledByUserName: $session.userName,
        scheduledForUserName: $session.userName,
        startDateString: round(
          date,
          moment.duration(30, "minutes"),
          "ceil"
        ).format("MM/DD/YYYY hh:mm a"), //new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), 0),
        endDateString: round(date, moment.duration(30, "minutes"), "ceil")
          .add("minutes", 60)
          .format("MM/DD/YYYY hh:mm a"), //new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), 0)
        timeZone: getEmunTimezone(timezone),
        alarmInterval: 0,
      };
      activity.id = "";
      activity.startDate = round(date, moment.duration(30, "minutes"), "ceil");
      activity.endDate = round(
        date,
        moment.duration(30, "minutes"),
        "ceil"
      ).add("minutes", 60);
      activity.retailerId = cart.retailerId;
      activity.type = cart.activityId;
      activity.title = cart.purchaser.companyName + ": " + cart.activityId;
      activity.scheduledForUserName = $session.userName;
      activity.scheduledForUserName = $session.userName;
      //console.info("string dates", activity.startDateString, activity.endDateString);

      bus
        .send("CreateActivity.json?jsconfig=ua,uaa", activity)
        .then(function (response) {
          //$rootScope.$emit("orderActivitySaved", cart, response);
          $rootScope.$broadcast("orderActivitySaved", response);
          cart.activityId = response.data.id;
          return update(prop, cartId);
        });
    } else {
      return update(prop, cartId);
    }
  }

  function update(prop, cartId, theCart = cart) {
    //if(!prop) return console.error('prop required to update cart');
    //prop = prop.split('.')[0];
    let request = { changedPropertyName: prop, id: cartId || theCart.id };
    request.token = theCart.token;

    for (var pn in theCart) {
      if (
        cantStartWith.filter((m) => pn.startsWith(m)).length === 0 &&
        cantEq.filter((m) => pn === m).length === 0 &&
        !angular.isFunction(theCart[pn])
      )
        //if(cantStartWith.filter(m => pn.startsWith(m)).length === 0 && cart[pn] && !angular.isFunction(cart[pn]))
        request[pn] = theCart[pn];
    }
    //let parsed = $parse(prop);
    //parsed.assign(request, parsed(theCart));
    $rootScope.$emit("cartUpdating", { theCart, request, prop });
    console.debug("cartUpdating", { theCart, request, prop });

    return bus
      .send("UpdateCart.json", request)
      .then(function (response) {
        let cartUpdated = response.data;
        //console.info("cartUpdated", cart, cartUpdated);
        $rootScope.$broadcast("cartUpdated", theCart, cartUpdated);
      })
      .catch(errorToastFactory("cartUpdateFailed/UpdateCart", request));
  }

  function applyGiftCard(giftCard, cartId) {
    let request = {
      cartId: cartId || cart.id,
      giftCard: giftCard || cart.giftCard,
    };
    return bus
      .send("ApplyGiftCard.json", request)
      .then(function () {
        return cart.load(request.id);
      })
      .catch(errorToastFactory("cartUpdateFailed/ApplyGiftCard", request));
  }

  function toggleRushOrderFee(cartId) {
    let request = {
      cartId: cartId || cart.id,
    };
    if (cart.isRushOrder) {
      return bus
        .send(`AddRushOrder.json`, request)
        .then(function () {
          return cart.load(request.cartId);
        })
        .catch(errorToastFactory("cartUpdateFailed/AddRushOrder", request));
    } else {
      return bus
        .send(`RemoveRushOrder.json`, request)
        .then(function () {
          return cart.load(request.cartId);
        })
        .catch(errorToastFactory("cartUpdateFailed/RemoveRushOrder", request));
    }
  }

  function applyDiscount(cartId, discount) {
    let request = {
      cartId: cartId || cart.id,
      discount: discount || cart.discountPercentage,
    };
    return bus
      .send("ApplyDiscount.json", request)
      .then(function () {
        $rootScope.$emit("discountApplied", {});
        return cart.load(request.id);
      })
      .catch(errorToastFactory("cartUpdateFailed/ApplyDiscount", request));
  }
  function selectDiscountProduct(
    promo,
    options = {
      backdrop: false,
      size: "lg",
      colSplit: 0,
      placement: "center",
    }
  ) {
    const $ctrl = this;
    promo.freeProducts = [];

    return cartItemPicker({
      title: "Select product to discount...",
      subTitle: "",
    }).then((result) => {
      promo.discountProductPosition = result.position;
      cart.applyPromo(promo, cart.id);
    });
  }

  function selectPromoProducts(
    promo,
    options = {
      backdrop: false,
      view: "list",
      size: "lg",
      colSplit: 0,
      placement: "center",
      criteria: { wholesalePriceGreaterThan: 0 },
    }
  ) {
    const $ctrl = this;
    promo.freeProducts = [];

    return promoProductPicker({
      title: "Select $" + promo.discountDollar + " in free product(s)...",
      subTitle: "",
      dollarsAllowed: promo.discountDollar,
    }).then((result) => {
      promo.freeProducts = result.map((p) => p.id);
      cart.applyPromo(promo, cart.id);
    });
  }

  function applyPromo(promo, cartId) {
    if (
      promo.promoCode &&
      promo.rewardType.toUpperCase() === "FREE PRODUCT CHOICE" &&
      !promo.freeProducts
    ) {
      //prompt for free products
      cart.selectPromoProducts(promo);
      return;
    }

    if (
      promo.promoCode &&
      promo.rewardType.toUpperCase() === "SINGLE PRODUCT DISCOUNT" &&
      !promo.discountProductPosition
    ) {
      //prompt for free products
      cart.selectDiscountProduct(promo);
      return;
    }

    let request = {
      cartId: cartId || cart.id,
      promoCode: promo.promoCode || promo || cart.promoCode,
      freeProducts: promo.freeProducts || [],
      discountProductPosition: promo.discountProductPosition || 0,
    };
    return bus
      .send(
        `ApplyPromoCode.json?Profiler=${
          $session.debugMode ? "Enabled" : "Disabled"
        }`,
        request
      )
      .then(function () {
        $rootScope.$emit("promoApplied", {});
        return cart.load(request.id);
      })
      .catch(errorToastFactory("cartUpdateFailed/ApplyPromoCode", request));
  }

  function clearPromo(promo, cartId) {
    let request = {
      cartId: cartId || cart.id,
      promoCode: promo.promoCode || cart.promoCode,
    };
    return bus
      .send(
        `ClearPromotion.json?Profiler=${
          $session.debugMode ? "Enabled" : "Disabled"
        }`,
        request
      )
      .then(function () {
        $rootScope.$emit("promoCleared", {});
        return cart.load(request.id);
      })
      .catch(errorToastFactory("cartUpdateFailed/ClearPromotion", request));
  }

  function deleteShippingLocation(shippingLocation) {
    return modals
      .confirm("Are you sure?", "Delete Address")
      .result.then(function () {
        let request = Object.assign({}, shippingLocation);
        if (cart.businessModel === "Wholesale") {
          bus
            .send("DeleteRetailerShippingLocation.json", request)
            .then(function () {
              return cart.load(request.cartId);
            })
            .catch(
              errorToastFactory(
                "cartUpdateFailed/DeleteRetailerShippingLocation",
                request
              )
            );
        } else {
          bus
            .send("DeleteConsumerShippingLocation.json", request)
            .then(function () {
              return cart.load(request.cartId);
            })
            .catch(
              errorToastFactory(
                "cartUpdateFailed/DeleteConsumerShippingLocation",
                request
              )
            );
        }
      });
  }

  function deletePaymentMethod(paymentMethod) {
    return modals
      .confirm("Are you sure?", "Delete Payment Method")
      .result.then(function () {
        let request = Object.assign({}, paymentMethod);
        if (cart.businessModel === "Wholesale") {
          bus
            .send("DeleteRetailerPaymentMethod.json", request)
            .then(function () {
              return cart.load(request.cartId);
            })
            .catch(
              errorToastFactory(
                "cartUpdateFailed/DeleteRetailerPaymentMethod",
                request
              )
            );
        } else {
          bus
            .send("DeleteConsumerPaymentMethod.json", request)
            .then(function () {
              return cart.load(request.cartId);
            })
            .catch(
              errorToastFactory("cartUpdateFailed/cartUpdateFailed", request)
            );
        }
      });
  }

  function openParser() {
    return orderParseItems({
      size: "lg",
    }).then((result) => {
      console.debug("result", result);
      window.location.reload();
    });
  }

  function openImport() {
    return orderImportItems({
      size: orderConfig.OrderImportItemsModalSize || "xl",
    }).then((result) => {
      console.debug("result", result);
      window.location.reload();
    });
  }


  function cancelOrder(cartId) {
    return modals
      .confirm("Are you sure?", "Cancel Order")
      .result.then(function () {
        bus
          .send("CancelOrder.json", { orderId: cartId })
          .then(function () {
            $rootScope.$emit("orderCancelled", {});
          })
          .catch(errorToastFactory("cartUpdateFailed/CancelOrder", cartId));
      });
  }

  function activateOrder(cartId) {
    return modals
      .confirm("Are you sure?", "Activate Order")
      .result.then(function () {
        bus
          .send("ActivateCart.json", { CartId: cartId })
          .then(function () {
            $rootScope.$emit("cartActivated", {});
          })
          .catch(errorToastFactory("cartActivateFailed/ActivateOrder", cartId));
      });
  }

  function applyShippingLocation(shippingLocation, cartId) {
    let request = Object.assign(
      { cartId: cartId || cart.id },
      shippingLocation
    );
    //request.update = true;
    request.phone = (request.phone || "").replace(/\D/gi, "");
    request.purchaser = request.retailer;
    request.token = cart.token;
    $rootScope.$emit("cartShippingLocationApplying", {
      cart,
      shippingLocation,
      request,
    });
    return bus
      .send(
        `ApplyShippingLocation.json?Profiler=${
          $session.debugMode ? "Enabled" : "Disabled"
        }`,
        request
      )
      .then((response) => {
        return cart.load(request.cartId).then(() => {
          $rootScope.$broadcast(
            "cartShippingLocationApplied",
            cart,
            shippingLocation,
            request,
            response
          );
          $rootScope.$broadcast("updateOrderApplied", {
            cart,
            shippingLocation,
            request,
            response,
          });
          $rootScope.$emit(
            "cartShippingLocationApplied",
            {
              cart,
              shippingLocation,
              request,
              response,
            },
            errorToastFactory("cartUpdateFailed")
          );
        });
      });
  }

  function approve(cartId) {
    return modals
      .confirm("Approve this order?", "Approve Order")
      .result.then(() => bus.send("ApproveCart.json?CartId=" + cartId))
      .then(() => cart.load())
      .catch(errorToastFactory("cartUpdateFailed/ApproveCart", cartId));
  }
  function requestPayment(cartId) {
    let request = { id: cartId || cart.id };
    bus.send("RequestPayment.json", request).then(function () {
      cart.load(cart.id);
    });
    //		cart.paymentMethodTransId = "REQUEST";
    //		cart.reasonCode = "Credit Card";
    //		cart.update("paymentMethodTransId").then(function () {
    //			cart.load(cart.id);
    //		});
  }
  function selfCheckout(cartId) {
    if (cart.shipOn == null && required.shipOn) {
      modals.alert("Ship Date is required");
      return;
    }
    if (cart.cancelOn == null && required.cancelOn) {
      modals.alert("Cancel Date is required");
      return;
    }
    let request = { id: cartId || cart.id, overridePaymentInformation: true };
    bus.validate("SubmitCart.json", request).then(function () {
      bus.send("RequestPayment.json", request).then(function () {
        cart.load(cart.id).then(function () {
          cart.hold(cart.id, "Credit Card");
          cart.bus
            .send("QueryRetailers.json?Id=" + cart.retailerId)
            .then(function (res) {
              var retailer = {};
              if (res.data.results.length) retailer = res.data.results[0];
              if (
                $session.isRepOrAbove() &&
                (cartConfig.askQuestions ||
                  (cartConfig.askQuestionsNewAccount && retailer.isNewAccount))
              ) {
                cart.orderQuestionsPrompt(cart.id, cart.retailerId);
              }
            });
        });
      });
    });

    //		cart.paymentMethodTransId = "REQUEST";
    //		cart.reasonCode = "Credit Card";
    //		cart.update("paymentMethodTransId").then(function () {
    //			cart.load(cart.id).then(function() {
    //				cart.hold(cart.id, "Credit Card");
    //			});
    //		});
  }
  function cancel(cartId) {
    return modals
      .confirm(
        "Are you sure you want to cancel this order.  This will make the order status Cancelled?",
        "Cancel Order"
      )
      .result.then(function () {
        let request = { id: cartId || cart.id };
        bus.send("CancelCart.json", request).then(function (response) {
          let cartUpdated = response.data;
          console.info("cartUpdated", {
            ...$state.current,
            cart,
            cartUpdated,
            cartConfig,
          });
          $rootScope.$broadcast("cartUpdated", cart, cartUpdated);
          cart.removeOrderFromSession(cartId);
          if (cart.orderCountInSession() > 0) {
            $state.transitionTo(
              $state.current.name.indexOf("cust.details.order") === 0
                ? "cust.details.order.detail"
                : "orders.detail",
              {
                ...$state.params,
                orderId: cart.ordersInSession()[0].id,
              }
            );
          } else {
            cart.reset();
            $state.transitionTo(
              $state.current.name.indexOf("cust.details.order") === 0
                ? "cust.details.order"
                : "orders",
              $state.params
            );
          }
        });
      });
  }
  function hold(cartId, reasonCode, customFields = {}) {
    let request = { id: cartId || cart.id };

    for (var pn in cart) {
      if (
        cantStartWith.filter((m) => pn.startsWith(m)).length === 0 &&
        cantEq.filter((m) => pn === m).length === 0 &&
        !angular.isFunction(cart[pn])
      )
        request[pn] = cart[pn];
    }
    request.status = "On Hold";

    const executeHoldCart = () =>
      bus.send("HoldCart.json", request).then(
        function (response) {
          let cartUpdated = response.data;
          console.info("cartUpdated", {
            ...$state.current,
            cart,
            cartUpdated,
            cartConfig,
          });
          $rootScope.$broadcast("cartUpdated", cart, cartUpdated);
          if (cartConfig.orderConfirmationPage || reasonCode == "Credit Card") {
            cart.removeOrderFromSession(cartId);
            cart.reset();
            $state.go("crm-confirmation", {
              cart: cartUpdated.id,
              orderNumber: cartUpdated.id,
            });
          } else {
            cart.removeOrderFromSession(cartId);
            if (cart.orderCountInSession() > 0) {
              $state.transitionTo(
                $state.current.name.indexOf("cust.details.order") === 0
                  ? "cust.details.order.detail"
                  : "orders.detail",
                {
                  ...$state.params,
                  orderId: cart.ordersInSession()[0].id,
                }
              );
            } else {
              cart.reset();
              //BL taking this out 1/1322 because no way to get to confirmation page in showroom mobile when placing on hold
              // if ($session.isShowroom() && $pageConfig.isMobile()) {
              // 	$state.transitionTo("home");
              // } else {
              if (cartConfig.orderConfirmationPage || $session.isShowroom()) {
                $state.go("crm-confirmation", { orderNumber: cartId });
              } else {
                $state.transitionTo(
                  $state.current.name.indexOf("cust.details.order") === 0
                    ? "cust.details.order"
                    : cartConfig.holdCartRoute || "orders",
                  $state.params
                );
              }
              //}
            }
          }
        },
        function error(res) {
          $rootScope.$emit("cartUpdateFailed", { cart, request, res });
          if (!res.data.responseStatus.errors)
            notify.error(res.data.responseStatus.message, {
              title: res.data.responseStatus.errorCode,
              ttl: 5000,
            });
        }
      );

    if (
      cartConfig.createUserOnCheckout &&
      cart.purchaser.email &&
      !customFields.skipCreateUser
    ) {
      return cart.bus
        .send("QueryUsers.json?Email=" + cart.purchaser.email)
        .then(function (res) {
          if (!res.data.results.length && !customFields.skipCreateUser) {
            return modals
              .confirm(
                `The email address ${cart.purchaser.email} is not associated with a registered user.  Would you like to create a user account?`
              )
              .result.then(
                function () {
                  cart.bus
                    .send("RegisterUser.json", {
                      autoLogin: false,
                      role: "Retailer",
                      retailerId: cart.retailerId,
                      password: "temporaryPassword",
                      confirmPassword: "temporaryPassword",
                      email: cart.purchaser.email,
                      confirmEmail: cart.purchaser.email,
                      permissions: "AllPermissions",
                      forceResetPassword: true,
                    })
                    .then(function () {
                      cart.hold(cartId, reasonCode, { skipCreateUser: true });
                    });
                },
                function () {
                  cart.hold(cartId, reasonCode, { skipCreateUser: true });
                }
              );
          } else cart.hold(cartId, reasonCode, { skipCreateUser: true });
        });
    }

    if (reasonCode) {
      request.reasonCode = reasonCode;
      return executeHoldCart();
    } else if (cartConfig.cartPlacedOnHoldWithReasonCodes) {
      return bus
        .read("QueryReasonCodes.json")
        .then(({ data: { results: reasonCodes } }) =>
          actionList({
            title: "Place On Hold...",
            body: "Please select your reason",
            actions: reasonCodes.map((rc) => ({ title: rc.code, rc })),
            size: "md",
          })
        )
        .then((a) => {
          request.reasonCode = a.rc.code;
          return executeHoldCart();
        });
    } else {
      return executeHoldCart();
    }
  }

  function applyOrderInfo(orderInfo, cartId) {
    let request = Object.assign({ cartId: cartId || cart.id }, orderInfo);
    return bus
      .send(
        `ApplyOrderHeaderInfo.json?Profiler=${
          $session.debugMode ? "Enabled" : "Disabled"
        }`,
        request
      )
      .then((response) => cart.load()) // scheduleLoad?
      .then(() => {
        $rootScope.$emit("cartHeaderInfoApplied", {
          cart,
          orderInfo,
          request,
          response,
        });
        $rootScope.$broadcast("updateOrderApplied", {
          cart,
          orderInfo,
          request,
          response,
        });
      })
      .catch(
        errorToastFactory("cartUpdateFailed/ApplyOrderHeaderInfo", request)
      );
  }

  function applyCVV(securityCode, cartId) {
    let request = {
      cartId: cartId || cart.id,
      CVV: securityCode || "",
    };
    return bus
      .send("ApplyCVV.json", request)
      .then((response) => {
        $rootScope.$emit("cvvApplied", { cart, request, response });
        if (cart.bus.validationErrors) {
          cart.bus.validate("SubmitCart.json", { id: cart.id });
        }
      })
      .catch(errorToastFactory("cartUpdateFailed/ApplyCVV", request));
  }

  function applyPaymentTerms(paymentTerms, cartId) {
    let request = Object.assign({ cartId: cartId || cart.id }, paymentTerms);
    request.token = cart.token;
    return bus
      .send(
        `ApplyPaymentTerms.json?Profiler=${
          $session.debugMode ? "Enabled" : "Disabled"
        }`,
        request
      )
      .then((response) => {
        cart.load();
        $rootScope.$emit("paymentTerms", {
          cart,
          paymentTerms,
          request,
          response,
        });
        $rootScope.$broadcast("updateOrderApplied", {
          cart,
          paymentTerms,
          request,
          response,
        });
      })
      .catch(errorToastFactory("cartUpdateFailed/ApplyPaymentTerms", request));
  }

  function applyPaymentMethod(paymentMethod, cartId) {
    if (
      (!paymentMethod.number ||
        !paymentMethod.expirationMonth ||
        !paymentMethod.expirationYear ||
        (shoppingConfig.requireCVV && !paymentMethod.securityCode)) &&
      !paymentMethod.token &&
      cart.businessModel !== "Wholesale"
    ) {
      return $q.reject("Missing information");
    }
    if (!paymentMethod.address) {
      paymentMethod.address =
        cart.billingLocation.address || cart.shippingLocation.address;
    }
    if (!paymentMethod.address2) {
      paymentMethod.address2 =
        cart.billingLocation.address2 || cart.shippingLocation.address2;
    }
    if (!paymentMethod.city) {
      paymentMethod.city =
        cart.billingLocation.city || cart.shippingLocation.city;
    }
    if (!paymentMethod.state) {
      paymentMethod.state =
        cart.billingLocation.state || cart.shippingLocation.state;
    }
    if (!paymentMethod.zip) {
      paymentMethod.zip = cart.billingLocation.zip || cart.shippingLocation.zip;
    }

    let request = Object.assign({ cartId: cartId || cart.id }, paymentMethod);
    request.phone = (request.phone || "").replace(/\D/gi, "");
    if (
      paymentMethod.personName &&
      paymentMethod.personName.full &&
      !paymentMethod.name
    ) {
      request.name = paymentMethod.personName.full;
    }
    request.fullName = request.name;
    request.personName = { full: request.name };
    delete request.expiresOn;
    $rootScope.$emit("cartPaymentMethodApplying", {
      cart,
      paymentMethod,
      request,
    });
    return bus
      .send(
        `ApplyPaymentMethod.json?Profiler=${
          $session.debugMode ? "Enabled" : "Disabled"
        }`,
        request
      )
      .then(function (response) {
        //$uibModalInstance.close(request);
        $rootScope.$emit("cartPaymentMethodApplied", {
          cart,
          paymentMethod,
          request,
          response,
        });
        return cart.load(request.cartId, cart.token);
      })
      .catch(errorToastFactory("cartUpdateFailed/ApplyPaymentMethod", request));
  }

  function applyShippingRate(shippingRate, cartId) {
    let request = {
      cartId: cartId || cart.id,
      shippingMethodId: shippingRate.objectId,
    };
    delete request.expiresOn;
    $rootScope.$emit("cartShippingRateApplying", {
      cart,
      shippingRate,
      request,
    });
    return bus
      .send("ApplyShippingRate.json", request)
      .then(function (response) {
        //$uibModalInstance.close(request);
        $rootScope.$emit("cartShippingRateApplied", {
          cart,
          shippingRate,
          request,
          response,
        });
        return cart.load(request.cartId);
      })
      .catch(errorToastFactory("cartUpdateFailed/ApplyShippingRate", request));
  }

  function enterItem(cartId) {
    return modals.open({
      templateUrl: "enterItem.html",
      controllerAs: "$ctrl",
      controller: function ($scope, $uibModalInstance, $session) {
        let $ctrl = this;
        let bus = ($ctrl.bus = cart.bus);

        $ctrl.title = "Add an order ready item";
        $ctrl.dismiss = $ctrl.cancel = function () {
          $uibModalInstance.close();
        };
        $ctrl.cartId = cartId;

        $ctrl.findProducts = function (search) {
          return bus
            .send("QueryProducts.json?DesignId=0&OrderBy=ManufacturerNumber", {
              search,
            })
            .then((res) => res.data.results);
        };

        $ctrl.selectProduct = function (product) {
          $ctrl.product = product;
          $ctrl.product.quantity = 1;
          $ctrl.url = "";
        };

        $ctrl.uploadImage = function (file) {
          $ctrl.uploading = {};
          let req = {
            request: $ctrl.request,
            files: [file],
          };

          $ctrl.bus.upload("CreateMedia.json", req).then((res) => {
            $ctrl.url = res.data.media[0].url;
          });
        };
        $ctrl.addProduct = $ctrl.submit = function () {
          let item = {
            cartId: $ctrl.cartId,
            productId: $ctrl.item,
            quantity: $ctrl.product.quantity,
            options: [{ FieldId: "CustomUrl", ValueId: $ctrl.url }],
          };
          cart.addItem(item, $ctrl.product, false);
          $uibModalInstance.close();
        };
      },
      size: "md",
    }).result;
  }

  function checkPromos(cartId) {
    if (!$session.isAuthenticated) return;
    let request = {
      cartId: cartId,
    };
    bus
      .send(
        `CheckPromotions.json?Profiler=${
          $session.debugMode ? "Enabled" : "Disabled"
        }`,
        request
      )
      .then(function (response) {
        cart.promos = response.data.results;
      })
      .catch(errorToastFactory("cartUpdateFailed/CheckPromotions", request));
  }

  function checkSplits(cartId) {
    bus
      .send("IsSplitNeeded.json", { OrderNumber: cartId })
      .then(function (response) {
        if (response.data.isSplitNeeded) {
          modals
            .confirm(
              "This order will be split.  Do you wish to continue?",
              "Split Order"
            )
            .result.then(function () {
              let busy = modals.busy(
                "Splitting order...",
                `Thank you for your patience as order ${cartId} is split.`
              );
              cart.scheduleLoad.cancel();
              bus
                .send("ProcessSplitOrder", { OrderNumber: cartId })
                .then(function (response) {
                  busy.close();
                  if (response.data.orders && response.data.orders.length > 0) {
                    modals.alert("Order has been split into multiple orders");
                    console.debug(
                      "Order has been split into multiple orders",
                      response.data.orders
                    );
                    cart
                      .addOrderToSession(...response.data.orders)
                      .then(() => cart.removeOrderFromSession(cartId));
                    //				cart.reset();
                    $state.transitionTo("orders.detail.lines", {
                      orderId: response.data.orders[0].id,
                    });
                  } else {
                    cart.checkout();
                  }
                });
            });
        } else {
          cart.checkout();
        }
      })
      .catch(errorToastFactory("cartUpdateFailed/CheckSplitOrder", cartId));
    //.finally(busy.close());
  }

  function checkOffers(cartId, displayType, productId) {
    const { [productId]: product } = productMap;
    let request = {
      cartId: cartId,
      productId: productId,
      offerType: displayType,
      token: cart.token
    };
    bus
      .send(
        `CheckCartOffers.json?Profiler=${
          $session.debugMode ? "Enabled" : "Disabled"
        }`,
        request
      )
      .then(function (response) {
        if (response.data.hasOffer) {
          return modals.open({
            templateUrl: "offer.html",
            controllerAs: "$ctrl",
            controller($scope, $uibModalInstance, $session) {
              let $ctrl = this;
              $ctrl.offer = response.data.offer;
              $ctrl.products = response.data.products;
              $ctrl.qualifyingPosition = response.data.qualifyingPosition;
              $ctrl.title = response.data.offer.description;
              $ctrl.dismiss = $ctrl.cancel = function () {
                $uibModalInstance.close();
                if (displayType === "Checkout") {
                  $state.go("checkout");
                } else {
                  cart.load(cartId);
                  $state.go("cart");
                }
              };
              $ctrl.continueShopping = function () {
                cart.load(cartId);
                $uibModalInstance.close();
                $state.go("shop");
              };
              $ctrl.cartId = cartId;
              $ctrl.addProduct = function (product) {
                let item = {
                  cartId: $ctrl.cartId,
                  productId: product.id,
                  parentPosition: $ctrl.qualifyingPosition,
                };
                cart.addItem(item, product, false, $ctrl.offer.id);
                $uibModalInstance.close();
                if (displayType === "Checkout") {
                  if (
                    $session.isSalesManagementMode() &&
                    cartConfig.splitOnCheckout
                  ) {
                    cart.checkSplits(cartId);
                  } else {
                    cart.checkout();
                  }
                } else {
                  cart.load(cartId);
                  $state.go("cart");
                }
              };
            },
            size: "lg",
          }).result;
        }
        //console.debug("Check Offers Reload", product, cart.items.length);
        if (displayType === "Checkout") {
          if ($session.isSalesManagementMode() && cartConfig.splitOnCheckout) {
            cart.checkSplits(cartId);
          // } else if (cartConfig.checkShipDateMinimumsBeforeCheckout) {
          //   cart.displayShipDateMinimumMessage = false;
          //   if (cart.shipDateMinimums.length) cart.displayShipDateMinimumMessage = true;
          //   else cart.checkout();
          } else {
            cart.checkout();
          }
        } else {
          cart.updateStats(true);
          return (product && product.isKitExplode) || cart.items.length == 1
            ? cart.load(cartId)
            : cart.scheduleLoad(cartId);
        }
      })
      .catch(errorToastFactory("cartUpdateFailed/CheckCartOffers", request));
  }

  function remember(cartId) {
    docCookies.setItem("cartId", cartId);
  }

  function forget() {
    docCookies.setItem("cartId", null);
    docCookies.removeItem("cartId");
  }

  function resetFields() {
    cart.id = cart.cartId = null;
    forget();
    Object.keys(cart).forEach((key) => {
      if (
        [
          "bus",
          "config",
          "cartTitle",
          "errorToastFactory",
          "shipOnsUrl",
        ].indexOf(key) >= 0 ||
        key.startsWith("$")
      )
        return;
      const val = cart[key];
      if (!_.isFunction(val)) {
        if (_.isFinite(val)) {
          cart[key] = 0;
        } else if (_.isArray(val)) {
          cart[key] = [];
        } else if (moment.isMoment(val)) {
          delete cart[key];
        } else if (_.isObject(val)) {
          cart[key] = {};
        } else {
          delete cart[key];
        }
      }
    });
    cart.shoppingConfig = shoppingConfig;
    cart.orderConfig = orderConfig;
    cart.$itemSearch = "";
  }

  function reset() {
    resetFields();
    docCookies.setItem("shared_cart_id", null);
    docCookies.setItem("shared_token", null);
    docCookies.removeItem("shared_cart_id");
    docCookies.removeItem("shared_token");
    $rootScope.$emit("cartResetting", { cart });
    return cart.load("RESET").then(function () {
      forget();
      $rootScope.$emit("cartReset", { cart });
    });
  }

  function applyPoints(
    item,
    points = item.product.points * item.qtyPurchased,
    cartId
  ) {
    console.debug("applyPoints", { points, item, cart: this });
    if (points < cart.availablePoints) {
      const request = {
        id: cartId || cart.id,
        cartId: cartId || cart.id,
        productId: item.productId,
        points,
        position: item.position,
      };
      cart.tryLockSku(request.productId);
      $rootScope.$emit("applyingPoints", { cartId, item, request });
      return bus
        .send(
          `ApplyPoints.json?Profiler=${
            $session.debugMode ? "Enabled" : "Disabled"
          }`,
          request
        )
        .then(function (response) {
          $rootScope.$broadcast("cartItemQuantityChanged", item, cart);
          notify.success(
            "Item " + item.productId + " applied points  " + points,
            {
              title: "Cart",
              ttl: 3000,
              disableCountDown: true,
            }
          );
          return cart.load(request.id);
        })
        .catch(errorToastFactory("cartUpdateFailed/ApplyPoints", request))
        .finally(() => cart.unlockSku(request.productId));
    } else {
      return modals.alert(
        `Insufficient points available: ${points} > ${cart.availablePoints}`
      );
    }
  }

  function changeQuantity(item, cartId) {
    // console.log("Change item qty!!");
    //console.debug("changeQuantity", item.qtyPurchased, {
    //	item,
    //	cartId,
    //	skuTimeouts,
    //});
    cart.canLockSku(item.productId);
    const cartType = (cart.type || "").toUpperCase();
    if (item.qtyPurchased === 0) {
      return !item.create && removeItem(item, cartId);
    }
    if (
      item.qtyPurchased < item.product.minimumOrderQty &&
      item.product.enforceMinimum &&
      cartType !== "SAMPLE" &&
      cartType !== "REPLACEMENT" &&
      cartType !== "DROP SHIP" &&
      cartType !== "RETURN"
    ) {
      item.qtyPurchased = item.product.minimumOrderQty;
      return modals.alert(
        "This item, " +
          item.productId +
          ", has reached it's minimum quantity (" +
          item.product.minimumOrderQty +
          ")."
      );
    }

    if (
      cartConfig.useCaseQtyIncrement &&
      item.product.purchaseIncrement &&
      item.product.caseQty &&
      item.qtyPurchased >= item.product.caseQty
    )
      item.product.purchaseIncrement = item.product.caseQty;
    if (
      item.product.purchaseIncrement > 0 &&
      item.product.enforceIncrement &&
      cartType !== "SAMPLE" &&
      cartType !== "REPLACEMENT" &&
      cartType !== "DROP SHIP" &&
      cartType !== "RETURN"
    ) {
      if (item.qtyPurchased % item.product.purchaseIncrement) {
        item.qtyPurchased = item.product.purchaseIncrement;
        const tm = () => {
          // $rootScope.$emit('minimumOrderQty:' + item.productId, { cart, item });
          $rootScope.$emit("minimumOrderQtyC:" + item.productId, {
            cart,
            item,
          });
        };
        return modals
          .alert(
            "Quantity must be in increments of " +
              item.product.purchaseIncrement
          )
          .result.then(() => {
            tm();
            $timeout(tm, 188);
          });
      }
    }
    if (item.create) {
      return;
    }
    let request = {
      id: cartId || cart.id,
      cartId: cartId || cart.id,
      productId: item.productId,
      quantity: item.qtyPurchased,
      position: item.position,
      token: cart.token
    };
    if (item.product && item.product.pricing) {
      Object.keys(item.product.pricing).forEach((key) => {
        if (item.qtyPurchased >= key) {
          item.price = item.product.pricing[key];
          item.pricePaid = item.product.pricing[key];
        }
      });
    }

    item.extendedTotal = item.qtyPurchased * item.price;
    item.subTotal = item.extendedTotal;
    cart.tryLockSku(item.productId);
    $rootScope.$emit("cartItemQuantityChanging", { cartId, item, request });
    return cart.bus
      .send(
        `ChangeCartItemQuantity.json?Profiler=${
          $session.debugMode ? "Enabled" : "Disabled"
        }`,
        request
      ) //?Profiler=Enabled
      .then(function (response) {
        response.data.origQty = response.data.qtyPurchased;
        request.qtyOpen = response.data.qtyOpen;
        Object.assign(cart.positionIndex[item.position], item, response.data);
        if (cart.$itemSearch !== "" && cart.$itemSearch === item.productId)
          cart.$itemSearch = "";
        $rootScope.$emit("cart-item-added");
        $rootScope.$broadcast("cart-item-added");

        notify.success(
          "Item " +
            item.productId +
            " added to cart.  Qty " +
            item.qtyPurchased,
          {
            title: "Cart",
            ttl: 2000,
            disableCountDown: true,
          }
        );

        $rootScope.$broadcast("cartItemQuantityChanged", {
          cartId,
          item,
          request,
          response,
        });
        cart.updateStats(true);
        if (item.product && item.product.isKitExplode) {
          return cart.load(request.id);
        } else {
          return cart.scheduleLoad(request.id);
        }
        //return cart.scheduleLoad(request.id);
      })
      .catch(function (request) {
        console.info("catch response error", request);
        if (cartConfig.playErrorSound) {
          var errorSound = new Audio("/sounds/alert.mp3");
          errorSound.load();
          errorSound.play();
          errorToastFactory("cartUpdateFailed/ChangeCartItemQuantity", request);
        } else {
          errorToastFactory("cartUpdateFailed/ChangeCartItemQuantity", request);
          notify.error(request.data.responseStatus.message, {
            title: "Cart",
            ttl: 2000,
            disableCountDown: true,
          });
        }
      })
      .finally(() => cart.unlockSku(request.productId));
  }

  function decrementItem(item, cartId) {
    if (
      cartConfig.useCaseQtyIncrement &&
      item.product.purchaseIncrement &&
      item.product.caseQty &&
      item.qtyPurchased <= item.product.caseQty
    )
      item.product.purchaseIncrement = item.product.origPurchaseIncrement;
    item.qtyPurchased = Math.max(
      0,
      item.qtyPurchased - (item.product.purchaseIncrement || 1)
    );
    if (skuTimeouts[item.productId]) {
      $timeout.cancel(skuTimeouts[item.productId]);
    }
    skuTimeouts[item.productId] = $timeout(
      () => cart.changeQuantity(item, cartId),
      cartConfig.changeQuantityTimeout
    );
  }

  function incrementItem(item, cartId) {
    if (
      cartConfig.useCaseQtyIncrement &&
      item.product.purchaseIncrement &&
      item.product.caseQty &&
      item.qtyPurchased >= item.product.caseQty
    ) {
      if (!item.product.origPurchaseIncrement)
        item.product.origPurchaseIncrement = item.product.purchaseIncrement;
      item.product.purchaseIncrement = item.product.caseQty;
    }
    item.qtyPurchased += item.product.purchaseIncrement || 1;

    if (skuTimeouts[item.productId]) {
      $timeout.cancel(skuTimeouts[item.productId]);
    }
    skuTimeouts[item.productId] = $timeout(
      () => cart.changeQuantity(item, cartId),
      cartConfig.changeQuantityTimeout
    );
    // console.debug("incrementItem", item.qtyPurchased, {
    //   item,
    //   cartId,
    //   skuTimeouts,
    // });
    // return cart.changeQuantity(item, cartId);
  }

  function processSplit(cartId) {
    return modals
      .confirm("Are you sure you want to split this order?", "Split Order")
      .result.then(function () {
        let busy = modals.busy(
          "Splitting order...",
          `Thank you for your patience as order ${cartId} is split.`
        );
        return bus
          .send("ProcessSplitOrder.json", {
            orderNumber: cartId,
          })
          .then(function (response) {
            $rootScope.$emit("orderSplit");
            let orders = cart.ordersInSession();
            if (orders.length > 0) {
              orders = orders.filter((o) => o.id !== cartId);
            }
            response.data.orders.forEach(function (ord) {
              orders.push({
                id: ord.id,
                name: ord.cartName || ord.id,
                companyName: ord.purchaser.companyName,
                customerID: ord.purchaser.id,
              });
            });

            console.info(
              "$localStorage.orders",
              ($localStorage.orders = orders)
            );
            //				cart.reset();
            if (response.data.orders.length > 0) {
              $state.transitionTo("orders.detail", {
                orderId: response.data.orders[0].id,
              });
            }
            busy.close();
            $rootScope.$apply();
          }, busy.close());
      });
  }

  function split(cartId, splitBy, keys) {
    return modals
      .confirm("Are you sure you want to split this order?", "Split Order")
      .result.then(function () {
        let busy = modals.busy(
          "Splitting order...",
          `Thank you for your patience as order ${cartId} is split.`
        );
        return bus
          .send("SplitOrder.json", {
            orderNumber: cartId,
            splitBy: splitBy,
            keys: keys,
          })
          .then(function (response) {
            $rootScope.$emit("orderSplit");
            let orders = cart.ordersInSession();
            if (orders.length > 0 && !keys) {
              orders = orders.filter((o) => o.id !== cartId);
            }
            response.data.orders.forEach(function (ord) {
              orders.push({
                id: ord.id,
                name: ord.cartName || ord.id,
                companyName: ord.purchaser.companyName,
                customerID: ord.purchaser.id,
              });
            });

            console.info(
              "$localStorage.orders",
              ($localStorage.orders = orders)
            );
            //				cart.reset();
            if (response.data.orders.length > 0) {
              $state.transitionTo("orders.detail", {
                orderId: response.data.orders[0].id,
              });
            }
            busy.close();
            $rootScope.$apply();
          }, busy.close());
      });
  }

  function prelimCopy(cartId) {
    return modals.dialog({
        body: `Would you like to retain pricing from current order?`,
        title: `Retain Pricing?`,
        size: 'md',
        buttons: {
            'Reprice New Order': {
                dismiss: true,
            },
            'Retain Pricing': {
              className: 'btn-u-default'
            },
        }
    }).result.then(
      () => cart.copy(cartId, false, false), 
    () => cart.copy(cartId, false, true));
  }

  function copy(cartId, overrideWarnings = false, reprice = false) {
    let url = `Reorder/${cartId}`;
    $rootScope.$emit("cartDuplicating", { cartId, url });
    let busy = modals.busy(
      "Copying order...",
      `Thank you for your patience as order ${cartId} is duplicated.`
    );
    let bus = new ServiceBus();
    return bus
      .send(url, {
        OrderNumber: cartId,
        RemoveLines: false,
        OverrideWarnings: overrideWarnings,
        Reprice: reprice
      })
      .then((response) => {
        $rootScope.$emit("cartDuplicated", { cart, cartId, url, response });
        console.debug("cartDuplicated", { cart, cartId, url, response });
        Object.assign(cart, response.data);
        response.data.messages.forEach((msg) =>
          (notify.warning || notify.error || notify.info)(msg, {
            ttl: 2000,
            disableCountDown: true,
          })
        );
        return load(cart.id).then(() => {
          cart.view({ mode: "Order", openedit: true });
          //$window.location.reload();
        });
      })
      .catch((response) => {
        if (response.data.responseStatus.errorCode === "Warning") {
          var body = "";
          response.data.responseStatus.errors.map(
            (e) => (body = body + e.message + "\r\n")
          );
          body = body + "\r\nContinue with copy?";
          return modals
            .confirm(body, "Some items cannot be copied", "lg")
            .result.then(function () {
              cart.copy(cartId, true, reprice);
            });
        } else {
          modals.alert(response.data.responseStatus.message);
        }
      })
      .finally(busy.close);
  }

  function prelimCopyToLocations(cartId, shipIds) {
    return modals.dialog({
        body: `Would you like to retain pricing from current order?`,
        title: `Retain Pricing?`,
        size: 'md',
        buttons: {
            'Reprice New Order': {
              dismiss: true,
            },
            'Retain Pricing': {
              className: 'btn-u-default'
            },
        }
    }).result.then(
      () => cart.copyToLocations(cartId, shipIds, false, false), 
    () => cart.copyToLocations(cartId, shipIds, false, true));

  }
  function copyToLocations(cartId, shipIds, overrideWarnings = false, reprice = false) {
    let url = `CopyOrderToLocations`;
    $rootScope.$emit("cartDuplicating", { cartId, url });
    let busy = modals.busy(
      "Copying order...",
      `Thank you for your patience as order ${cartId} is duplicated.`
    );
    let bus = new ServiceBus();
    return bus
      .send(url, {
        OrderNumber: cartId,
        ShipIds: shipIds,
        OverrideWarnings: overrideWarnings,
        Reprice: reprice
      })
      .then((response) => {
        $rootScope.$emit("cartDuplicated", { cart, cartId, url, response });
        console.debug("cartDuplicated", { cart, cartId, url, response });
//        Object.assign(cart, response.data);
        response.data.messages.forEach((msg) =>
          (notify.warning || notify.error || notify.info)(msg, {
            ttl: 2000,
            disableCountDown: true,
          })
        );
        //go to orders view
        $state.transitionTo("orders");
        $rootScope.$broadcast("refreshGrid");
      })
      .catch((response) => {
        if (response.data.responseStatus.errorCode === "Warning") {
          var body = "";
          response.data.responseStatus.errors.map(
            (e) => (body = body + e.message + "\r\n")
          );
          body = body + "\r\nContinue with copy?";
          return modals
            .confirm(body, "Some items cannot be copied", "lg")
            .result.then(function () {
              cart.copyToLocations(cartId, shipIds, true, reprice);
            });
        } else {
          modals.alert(response.data.responseStatus.message);
        }
      })
      .finally(busy.close);
  }

  function duplicate(cartId) {
    var duplicateOrderActions = {
      "Copy Entire Order": {
        icon: "cart-plus",
        body: "Copy all line items to a new order",
        handler: () => {
          cart.prelimCopy(cartId);
        },
      },
      "Select Items to Copy": {
        icon: "edit",
        body: "Select line items to copy to a new order",
        handler: function () {
          return orderManualCopy({
            size: "xl",
            title:
              "Select line items from the below list to copy to a new order",
          }).then((result) => console.debug("result", result));
        },
      },
      "Copy to multiple locations": {
        icon: "truck",
        body: "Select shipping locations to copy",
        handler: function () {
          return LocationPicker({
            title: "Select Shipping Location...",
            subTitle: "",
            applyTagsButtonText: false,
            single: false,
            criteria: {
              RetailerId: cart.retailerId
            },
            viewSelections: false, 
          }).then((result) => {
            cart.prelimCopyToLocations(cartId, result);
          });
        }
      },
    };
    return actionList({
      title: "Copy Order",
      body: "How would you like to copy this order?",
      actions: duplicateOrderActions,
      size: "md",
    }).then((a) => a.handler());
  }

  function loadShowSettings() {
    cart.numCopies = 1;
    cart.printer = "";
    cart.bus.send("GetShowSettings.json").then((res) => {
      cart.printer = res.data.defaultPrinter;
      cart.printWithImages = res.data.defaultOrderPrintIncludeImages;
      cart.numCopies = res.data.orderCopiesToPrint;
    });
  }

  function checkCategoryRestrictions() {
    if (!$session.isAuthenticated) return;
    cart.bus
      .send("CheckCategoryRestrictionsMin.json?CartId=" + cart.id)
      .then(function (response) {
        cart.categoryRestrictions = response.data;
      })
      .catch(errorToastFactory("cartUpdateFailed", cart.id));
  }

  function checkVendorMinimums() {
    if (!$session.isAuthenticated) return;
    cart.bus
      .send("CheckVendorMinimums.json?CartId=" + cart.id)
      .then(function (response) {
        cart.vendorMinimums = response.data;
      })
      .catch(
        errorToastFactory("cartUpdateFailed/CheckVendorMinimums", cart.id)
      );
  }

  function checkShipDateMinimums() {
    if (!$session.isAuthenticated) return;
    cart.bus
      .send("CheckShipDateMinimums.json?CartId=" + cart.id)
      .then(function (response) {
        cart.shipDateMinimums = response.data;
      })
      .catch(
        errorToastFactory("cartUpdateFailed/CheckShipDateMinimums", cart.id)
      );
  }

  function checkVolumeMinimums() {
    if (!$session.isAuthenticated) return;
    cart.bus
      .send("CheckVolumeMinimums.json?CartId=" + cart.id)
      .then(function (response) {
        cart.volumeMinimums = response.data;
      })
      .catch(
        errorToastFactory("cartUpdateFailed/CheckVolumeMinimums", cart.id)
      );
  }

  function fundboxCheckout() {
    var fbxHandler = FbxCheckout.configure({
      fbxKey: shoppingConfig.fundboxCheckout.key,
      env: "https://checkout-integration.fundboxpay.com",
      onComplete: function (fbxOrderToken) {
        cart.paymentMethodTransId = fbxOrderToken;
        cart.update("paymentMethodTransId").then(function () {
          cart.submit(cart.id);
        });
      },
    });

    var fundboxArgs = {
      ctaType: "confirm-terms",
      orderDetails: {
        amount_cents: (cart.grandTotal * 100).toString(),
        shipping_amount_cents: "0",
        checkout_items: cart.items.map((ci) => ({
          name: ci.productId,
          sku: ci.productId,
          description: ci.description.replace(/["']/g, ""),
          total_amount_cents: (ci.extendedTotal * 100).toString(),
          item_amount_cents: (ci.extendedTotal * 100).toString(),
          quantity: 1,
        })),
      },
    };
    //console.info("BL*** fundbox details = " + JSON.stringify(fundboxArgs));
    fbxHandler.open(fundboxArgs);
  }
  function getWishlist() {
    let request = {
      listId: "WISHLIST",
      criteria: {
        listId: "WISHLIST",
      },
    };
    //cart.bus
    //  .send("QueryProducts.json?src=CartWishlist", request)
    //  .then(function(response) {
    //    cart.wishlist = Product.map(response.results);
    //  });
  }

  function removeWishlistItem(item) {
    let request = {
      ProductId: item.id,
    };
    return bus
      .send("RemoveFromWishList.json", request)
      .then(function (response) {
        if (response.status === "200") {
          cart.getWishlist();
        }
      })
      .catch(errorToastFactory("cartUpdateFailed/RemoveFromWishList", request));
  }

  function load(cartId, token, options) {
    const { suppressFromSession = false, validate = false } = options || {};
    if (!cartId) cartId = cart.id;
    console.warn('loading cart', cartId, options);
    if (!token && cart.token) token = cart.token;
    let $rootScope = resolve("$rootScope");
    if (cart.loading) {
      console.warn("cart already loading...", cart.loading);
      return cart.$loading;
    }
//    cartId = (cartId || "NO_CART_ID").replace(/\//g, "FORWARDSLASH");
    let url = `Cart/${cartId}.json${token ? `?Token=${token}` : ""}`;
    cart.loading = new Date();

    console.warn("cartLoading", { cartId, url });
    $rootScope.$emit("cartLoading", { cartId, url });
    return (cart.$loading = bus.send(url, cartConfig.getCartRequest(cart)).then(
      function (response) {
        //console.info('response', response);
        let currentCartId = cart.id;
        cart.loaded = new Date();
        cart.token = token;
        resetFields();
        if (response.data.results.length) {
          cart.found = new Date();
          cart.reviewReason = null;
          cart.note = null;
          Object.assign(cart, response.data.results[0]);

          if (
            cart.status === "On Hold" &&
            cart.reasonCode === "Design Approval"
          )
            cart.approvalNeeded = true;
          if (cart.status === "Open" && cart.reasonCode === "Approved")
            cart.approved = true;
          // console.info("cart found", url);
          cart.$orderedOn = cart.orderedOn;
          cart.$shipOn = cart.shipOn;
          cart.$cancelOn = cart.cancelOn;
          //console.info('expecte to clear', cart.expectedToClear);
          cart.$expectedToClear = cart.expectedToClear;
          cart.multiCartId = cart.multiCartId || cart.id;
          cart.shipOn = moment.utc(cart.shipOn).startOf("day");
          cart.orderedOn = moment.utc(cart.orderedOn).startOf("day");
          if (cart.expectedToClear !== undefined) {
            cart.expectedToClear = moment
              .utc(cart.expectedToClear)
              .startOf("day");
          }

          //console.info('expecte to clear', cart.expectedToClear);
          cart.today = moment.utc();
          //cart.shipOn = shipOnMoment.format(cartConfig.dateFormat);
          if (!!cart.cancelOn) {
            cart.cancelOn = moment.utc(cart.cancelOn).startOf("day"); //.format(cartConfig.dateFormat);
          } else {
            cart.cancelOn = null;
          }
          //cart.cancelOn = cancelOnMoment.format(cartConfig.dateFormat);

          cart.mode = /quote/gi.test(cart.status || "") ? "Quote" : "Order";

          docCookies.setItem("cartId", cart.id);
          //console.log(url, cart);
          cartConfig.cartLoading && cartConfig.cartLoading(cart, $session);
          // https://emun1.monday.com/boards/333027351/views/4635648/pulses/2397584138
          cart.updateStats(false); //false b/c we just retrieved totals from server
          cart.calculatedOn = "";
          delete cart.calculatedOn;
          $rootScope.$broadcast("cartUpdated", cart);
          if (cart.id !== currentCartId) {
            $rootScope.$broadcast("cartInitialized", cart, response);
            lockedSkus = {};
            skuTimeouts = {};
            if (cartConfig.showCommitments && (!$session.meta.CurrentRetailerId || $session.meta.CurrentRetailerId !== cart.retailerId)) {
              bus.send("QueryUsers.json?Id=" + $session.userAuthId).then(function(res) {
                if (res.data.results.length) {
                  let user = res.data.results[0];
                  user.meta["CurrentRetailerId"] = cart.retailerId;
                  user.meta["CurrentRetailerName"] = cart.billingLocation.companyName;
                  bus.send("UpdateUser.json", user).then(res => {
                    window.location.reload();
                  });
                }
              });
            }
          }
          if (bus.validationErrors || validate) {
            bus.validate("SubmitCart.json", { id: cart.id });
          }
        } else {
          delete cart.found;
          cart.id = null;
          console.warn("no cart found", url);
        }
        // console.debug("cartLoaded", { cart, cartId, url, response });
        $rootScope.$broadcast("cartLoaded", { cart, cartId, url, response });
        cartConfig.cartLoaded && cartConfig.cartLoaded(cart, $session);
        // $timeout(() => $rootScope.$apply(), 100);
        !shoppingConfig.disableWishlist && cart.getWishlist();
        !cartConfig.hidePromoStatus && cart.checkPromos(cartId);
        cart.loading = false;
        cart.$loading = false;
        
        if (cart.id && $session.isAuthenticated) {
          if (cartConfig.categoryRestrictions) {
            cart.checkCategoryRestrictions();
          }
          if (cartConfig.vendorMinimums) {
            cart.checkVendorMinimums();
          }
          if (cartConfig.shipDateMinimums) {
            cart.checkShipDateMinimums();
          }
          if (cartConfig.volumeMinimums) {
            cart.checkVolumeMinimums();
          }
          if ($session.isShowroom()) {
            cart.loadShowSettings();
          }
          //if sales management add to local storage
          if (
            $session.isSalesManagementMode() &&
            cart &&
            cart.id &&
            !suppressFromSession
          ) {
            //console.info('suppressFromSession', suppressFromSession);
            cart.addOrderToSession(cart);
          }
        }
        if (cart.retailerId && cart.retailerId.toString().startsWith("CUST")) {
          cartConfig.newCustomer = true;
        } else {
          cartConfig.newCustomer = false;
        }
        if (
          cart.shippingLocationId &&
          cart.shippingLocationId.toString().startsWith("LOC")
        ) {
          cartConfig.newShipTo = true;
        } else {
          cartConfig.newShipTo = false;
        }
        cart.token = token;
        if (validate) {
          return bus
            .validate("SubmitCart.json", { id: cart.id })
            .then(() => cart);
        }
        cart.hydrateSessionOrders();
        return cart;
      },
      function (response) {
        cart.loaded = cart.failed = new Date();
        cart.loading = false;
        cart.$loading = false;
      }
    ));
  }

  function updateStats(includeTotals = false) {
    if (cartConfig.includeComponentsInItemIndex) {
      cart.positionIndex = _.indexBy(cart.items, "position"); //groupBy
      cart.itemsBySku = _.groupBy(cart.items, "productId"); //groupBy
    } else {
      cart.positionIndex = _.indexBy(
        cart.items.filter((c) => c.isKitComponent === false),
        "position"
      ); //groupBy
      cart.itemsBySku = _.groupBy(
        cart.items.filter((c) => c.isKitComponent === false),
        "productId"
      ); //groupBy
    }

    // cart.itemsBySku = _.groupBy(cart.items, "productId"); //groupBy
    cart.itemIndex = {};
    for (const sku in cart.itemsBySku) {
      cart.itemsBySku[sku] = orderBy(
        cart.itemsBySku[sku],
        ["shipOn", (i) => (i.isKitComponent ? 1 : 0)],
        ["asc", "asc"]
      );
      cart.itemIndex[sku] = cart.itemsBySku[sku][0];
    }

    const missingProductIds = Object.keys(cart.itemsBySku)
      .filter((sku) => !(sku in productMap))
      .sort();
    cart.shipOnIndex = _.indexBy(cart.items, "shipOn"); //groupBy
    const queryProductsParams = {
      op: "HydrateCartProducts",
      CartId: cart.id,
      OnlyCartItems: cart.id,
      CartToken: cart.token,
      IncludeInactive: true,
      IdIn: missingProductIds.join(",") || "NONE",
      Take: cart.items.length || 500,
    };
    if (missingProductIds.length > 50) {
      delete queryProductsParams.IdIn;
    }
    bus.read("QueryProducts.json", queryProductsParams).then(({ data }) => {
      Object.assign(productMap, _.indexBy(data.results, "id")); //groupBy
      cart.items = cart.items.map(
        (ci) =>
          new CartItem(Object.assign(ci, { product: productMap[ci.productId] }))
      );
      if (cartConfig.includeComponentsInItemIndex) {
        cart.positionIndex = _.indexBy(cart.items, "position"); //groupBy
        cart.itemsBySku = _.groupBy(cart.items, "productId"); //groupBy
      } else {
        cart.positionIndex = _.indexBy(
          cart.items.filter((c) => c.isKitComponent === false),
          "position"
        ); //groupBy
        cart.itemsBySku = _.groupBy(
          cart.items.filter((c) => c.isKitComponent === false),
          "productId"
        ); //groupBy
      }
      for (const sku in cart.itemsBySku) {
        cart.itemsBySku[sku] = orderBy(
          cart.itemsBySku[sku],
          ["shipOn", (i) => (i.isKitComponent ? 1 : 0)],
          ["asc", "asc"]
        );
        cart.itemIndex[sku] = cart.itemsBySku[sku][0];
      }
      cart.designIndex = _.indexBy(
        cart.items,
        (item) => item.options.length && item.options[0].valueId
      );
      cart.skus = _.groupBy(cart.items, "productId"); //groupBy
      cart.applied_promos = [...new Set(cart.items.map((x) => x.promoCode2))];
      for (const productId in cart.skus) {
        const [firstOfSku] = cart.skus[productId];
        firstOfSku.firstOfSku = true;
        firstOfSku.shipOns = {};
        for (const line of cart.skus[productId]) {
          firstOfSku.shipOns[line.shipOn] = line.position;
        }
      }
      //BL had to separate some of these calculations that needed to be done every load
      Object.assign(cart, refreshProductStats());
      if (includeTotals) {
        Object.assign(cart, calculateTotals());
      }
      cart.getUniqueShipDates();
    });
    $rootScope.$broadcast("cartStatsUpdated", cart);
  }

  function refreshProductStats() {
    const result = cart.items.reduce(
      (r, l) => {
        r.availableTotal +=
          l.product && l.product.availableQty > 0
            ? l.price *
                (l.product.availableQty < l.qtyPurchased
                  ? l.product.availableQty
                  : l.qtyPurchased) || 0
            : 0;
        r.shippableTotal +=
          l.product && l.product.availableQty > 0
            ? l.price *
                (l.product.availableQty < l.qtyOpen
                  ? l.product.availableQty
                  : l.qtyOpen) || 0
            : 0;
        r.weight += l.product ? l.product.weight * l.qtyPurchased || 0 : 0;
        r.availableWeight +=
          l.product && l.product.availableQty > 0
            ? l.product.weight *
              (l.product.availableQty < l.qtyPurchased
                ? l.product.availableQty
                : l.qtyPurchased)
            : 0;
        r.cubicVolume += l.product
          ? l.product.cubicVolume * l.qtyPurchased || 0
          : 0;
        r.cubicVolumePercentage =
          cart.container != undefined
            ? (r.cubicVolume / cart.container.cubicVolume) * 100
            : 0;
        r.availableCubicVolume +=
          l.product && l.product.availableQty > 0
            ? l.product.cubicVolume *
              (l.product.availableQty < l.qtyPurchased
                ? l.product.availableQty
                : l.qtyPurchased)
            : 0;
        return r;
      },
      {
        weight: 0,
        availableWeight: 0,
        cubicVolume: 0,
        availableCubicVolume: 0,
        availableTotal: 0,
        shippableTotal: 0,
      }
    );
    return result;
  }
  function calculateTotals() {
    const result = cart.items.reduce(
      (r, l) => {
        r.itemCount += 1;
        r.qtyPurchased += l.qtyPurchased || 0;
        r.qtyOpen += l.qtyOpen || 0;
        r.caseQtyPurchased += l.caseQtyPurchased || 0;
        r.extendedQtyPurchased += l.extendedQtyPurchased || 0;
        r.openSubTotal += (l.qtyOpen || 0) * l.price;
        r.openTotal += (l.qtyOpen || 0) * l.price;
        r.shippableTotal +=
          l.product && l.product.availableQty > 0
            ? l.price *
                (l.product.availableQty < l.qtyOpen
                  ? l.product.availableQty
                  : l.qtyOpen) || 0
            : 0;
        r.qtyFree += l.qtyFree || 0;
        //r.availableTotal += l.product && l.product.availableQty > 0 ? ((l.price * (l.product.availableQty < l.qtyPurchased ? l.product.availableQty : l.qtyPurchased) || 0)) : 0;
        //r.weight += l.product ? ((l.product.weight * l.qtyPurchased) || 0) : 0;
        //r.availableWeight += l.product && l.product.availableQty > 0 ? l.product.weight * ((l.product.availableQty < l.qtyPurchased) ? l.product.availableQty : l.qtyPurchased) : 0;
        //r.cubicVolume += l.product ? (l.product.cubicVolume * l.qtyPurchased) || 0 : 0;
        //r.availableCubicVolume += l.product && l.product.availableQty > 0 ? l.product.cubicVolume * ((l.product.availableQty < l.qtyPurchased) ? l.product.availableQty : l.qtyPurchased) : 0;
        // r.cubicVolumePercentage += (l.cubicVolumePercentage || 0);
        r.discount += l.discount || 0;
        r.promoDiscount += l.promoDiscount || 0;
        r.subTotal += l.subTotal || 0;
        // r.taxableTotal += l.taxableTotal || 0;
        r.points += l.points || 0;
        return r;
      },
      {
        itemCount: 0,
        qtyPurchased: 0,
        qtyOpen: 0,
        caseQtyPurchased: 0,
        extendedQtyPurchased: 0,
        openSubTotal: 0,
        shippableTotal: 0,
        qtyFree: 0,
        //weight: 0,
        //availableWeight: 0,
        //cubicVolume: 0,
        //availableCubicVolume: 0,
        //   cubicVolumePercentage: 0,
        discount: 0,
        promoDiscount: 0,
        subTotal: 0,
        // taxableTotal: 0,
        points: 0,
        //availableTotal: 0,
        openTotal: 0,
        // grandTotal: 0,
        calculatedOn: new Date(),
      }
    );
    result.grandTotal =
      result.subTotal +
      cart.freight +
      cart.supplyChainFee +
      cart.creditCardFee +
      (result.salesTax || 0) +
      (result.freight || 0) -
      (result.discount || 0) -
      (result.promoDiscount || 0) -
      (result.giftCardDiscount || 0);
    result.shippableTotal = result.shippableTotal - (result.discount || 0);
    return result;
  }

  function getOrCreateCartForVendor(vendorId, multiCartId, status) {
    return bus
      .read("QueryCarts.json", {
        vendorId,
        multiCartId: multiCartId || cart.id,
        status: status,
        fields: "Id,MultiCartId",
        op: "getOrCreateCartForVendor",
        DontIncludeProducts: true,
      })
      .then(
        ({
          data: {
            results: [c],
          },
        }) =>
          c ||
          createCart({
            cartName: $session.isSalesManagementMode()
              ? ""
              : shoppingConfig.generateCartName(),
            vendorId,
            status: status,
            multiCartId,
            businessModel: $session.businessModel,
            purchaser: cart.purchaser,
            retailerId: cart.retailerId,
            purchaserId: cart.purchaserId,
            shippingLocation: cart.shippingLocation,
            sourceId:
              cart.sourceId === "VIRTUAL" || cart.sourceId === "Virtual"
                ? cart.sourceId
                : $session.isShowroom()
                ? $session.meta["DefaultOrderSourceShow"]
                : $session.isCorpOrAbove()
                ? $session.meta["DefaultOrderSourceCorp"]
                : $session.meta["DefaultOrderSourceRoad"],
            showCodeId: $session.isShowroom() ? $session.meta["ShowCode"] : "",
            shipOn: moment
              .utc()
              .startOf("day")
              .add("days", cart.orderConfig.shipDateDays || 0),
          })
      );
  }

  function mergeCarts() {
    return bus.send("MergeCarts.json", { cartId: cart.id }).then((response) => {
      //console.debug("cartsMerged", {
      //	cart: response.data,
      //	merged: response.data,
      //	cartId: response.data.id,
      //});
      $rootScope.$emit("cartsMerged", {
        cart: response.data,
        merged: response.data,
      });
      return cart.load(response.data.id || cart.id).then(
        (res) => console.info("cartsMerged", { res, cartId: response.data.id }),
        (res) => {
          console.warn("not merged");
          cart.reset();
        }
      );
    });
  }

  function editBilling() {
    const retailerPrompt = new RetailerPrompt();
    return retailerPrompt.edit(cart.purchaser).then((retailer) => {
      //console.debug("retailer.primaryContact", retailer.primaryContact);
      cart.purchaser = retailer;
      cart.buyer = retailer.contact;
      cart.billingLocation = retailer.billingLocation;
      cart.billingLocation.phone = retailer.phone;
      cart.purchaser.companyName = retailer.companyName;

      if (!cart.shippingLocation.id || !cart.shippingLocation.address) {
        return cart.bus
          .send(
            "QueryRetailerShippingLocations.json?Status=Active&RetailerId=" +
              retailer.id
          )
          .then(function (res) {
            if (res.data.results.length === 1) {
              cart.shippingLocation = res.data.results[0];
              return cart.update().then(() => cart.load());
            }
          });
      } else {
        return cart.update().then(() => cart.load());
      }
    });
  }

  function createPrompt(dto) {
    if ($session.isSalesManagementMode() || cartConfig.advancedCreateOrder) {
      if ($session.isRetailer() && $session.retailerId) {
        return cart.bus
          .send("QueryRetailers.json?Id=" + $session.retailerId)
          .then(function (res) {
            const model = {
              status: "Cart",
              ...dto,
              retailerId: $session.retailerId,
              retailer: res.data.results[0],
            };
            cart.retailerId = "";
            return OrderDetailsPrompt.open({ model }).then((c) => {
              Object.assign(cart, c);
              return cart.load(c.id);
            });
          });
      } else {
        cart.retailerId = "";
        return OrderDetailsPrompt.open({ model: dto || {} }).then((c) => {
          Object.assign(cart, c);
          return cart.load(c.id);
        });
      }
    } else {
      return createCartPrompt({}).then((c) => {
        Object.assign(cart, c);
        return cart.load(c.id);
      });
    }
  }

  /*	function createPrompt(dto) {
											  if ($session.isSalesManagementMode()) {
												  if ($session.isRetailer() && $session.retailerId) {
													  ServiceBus.send("QueryRetailers.json?Id=" + $session.retailerId).then(
														  function (res) {
															  dto = {
																  retailer: res.data.results[0],
																  status: "Cart"
															  };
															  cart.reset().then(function () {
																  cart.retailerId = "";
																  return OrderDetailsPrompt.open({ model: dto || {} }).then(c => {
																	  Object.assign(cart, c);
																	  return cart.load(c.id);
																  });
															  });
														  }
													  );
												  } else {
													  cart.reset().then(function () {
														  cart.retailerId = "";
														  return OrderDetailsPrompt.open({ model: dto || {} }).then(c => {
															  Object.assign(cart, c);
															  return cart.load(c.id);
														  });
													  });
												  }
											  } else {
												  return createCartPrompt({}).then(c => {
													  Object.assign(cart, c);
													  return cart.load(c.id);
												  });
											  }
										  }
										  */

  function createCart(dto) {
    return bus.send("CreateCart.json", dto || cart).then(
      function (response) {
        cart.id = response.data.id;
        $rootScope.$emit("cartCreated", {
          cart: response.data,
          created: response.data,
        });
        return response.data;
      },
      function (response) {
        if (response.data.responseStatus.errorCode)
          modals.alert(response.data.responseStatus.message);
      }
    );
  }

  function exitOrder(orderId = cart.id, redirect = orderId === cart.id) {
    console.debug("exitOrder", {
      orderId,
      redirect,
      cart,
      same: orderId === cart.id,
    });
    cart.removeOrderFromSession(orderId);
    if (redirect || cart.orderCountInSession() <= 1) {
      if (cart.orderCountInSession() > 0) {
        cart.id = cart.ordersInSession()[0].id;
        $state.transitionTo(
          $state.current.name.indexOf("cust.details.order") === 0
            ? "cust.details.order.detail"
            : cart.orderConfig.defaultDetailRoute || "orders.detail",
          {
            ...$state.current.params,
            orderId: cart.ordersInSession()[0].id,
          }
        );
      } else if (orderId === cart.id) {
        cart.reset();
        $state.transitionTo(
          cartConfig.routeAfterCloseLastSessionOrder(
            cart,
            $session,
            $pageConfig
          )
        );
      }
    }

    return cart.ordersInSession();
  }

  function ensureCart() {
    //console.log('ensureCart', cart.id);
    if (!cart.id) {
      let request = {
        cartName: shoppingConfig.generateCartName(),
        businessModel: $session.businessModel,
        purchaser: {
          id: $session.retailerId,
        },
      };
      let promise = $session.isRepOrAbove()
        ? createPrompt()
        : createCart(request);
      return promise.then((c) => {
        //console.info("c", c);
        Object.assign(cart, c);
        return cart.load(c.id);
      });
    }
    return $q.when(cart);
  }

  function createOptions() {
    let results = [];
    angular.forEach(arguments, (a) =>
      angular.forEach(a, (valueId, fieldId) =>
        results.push({ fieldId, valueId })
      )
    );
    return results;
  }

  function downloadImagesPrompt(cartId) {
    return DownloadImagesPrompt({
      //subTitle: cart.purchaser.id,
      id: cartId || cart.id,
      productId: this.productId,
      position: this.position,
    });
  }

  function changeOptions(item, part) {
    let request = item;
    let cartId = request.cartId;
    if (part) part.cartStatus = "processing";
    cart.tryLockSku(request.productId);
    $rootScope.$emit("cartItemOptionsChanging", {
      cartId,
      item,
      request,
      token: cart.token,
    });
    return bus
      .send(
        `ChangeCartItemOptions.json?Profiler=${
          $session.debugMode ? "Enabled" : "Disabled"
        }`,
        request
      )
      .then(function (response) {
        $rootScope.$emit("cartItemOptionsChanged", {
          cartId,
          item,
          request,
          response,
        });
        if (part) part.cartStatus = "success";
        if (!part) return cart.load(request.cartId, cart.token);
      })
      .finally(() => cart.unlockSku(request.productId));
  }

  function copyItem(item, cartId) {
    return ensureCart().then(() => {
      return modals
        .confirm("Are you sure?", "Copy Item " + item.product.id + "?")
        .result.then(function () {
          let clone = Object.assign({}, item);
          clone.quantity = clone.qtyPurchased = item.product.minimumOrderQty;
          clone.cartId = cartId || cart.cartId || cart.id;
          return addItem(clone, item.product, true);
        });
    });
  }

  function addProductById(
    productId,
    cartId,
    force,
    comments,
    quantity,
    options,
    optionGroupList,
    shipOn
  ) {
    return Product.get(productId).then((product) =>
      addProduct(
        product,
        cartId,
        force,
        comments,
        quantity,
        options,
        optionGroupList,
        shipOn
      )
    );
  }

  function addProduct(
    product,
    cartId,
    force,
    comments,
    quantity,
    options,
    optionGroupList,
    shipOn
  ) {
    let item = product.createCartItem
      ? product.createCartItem(
          cartId,
          comments,
          quantity,
          options,
          optionGroupList,
          shipOn
        )
      : {
          cartId: cartId || cart.cartId || cart.id,
          productId: product.id,
          quantity: quantity || product.minimumOrderQty || 1,
          qtyPurchased: quantity || product.minimumOrderQty || 1,
          comments: comments,
        };
    return addItem(item, product, force);
  }

  function addMultipleItems(products) {
    var qty = 1;
    var lines = [];
    const cartType = (cart.type || "").toUpperCase();
    bus.validationErrors = [];
    products.forEach(function (item) {
      var product = item.product;
      if (item.quantity > qty) {
        qty = parseInt(item.quantity);
      } else if (
        product.minimumOrderQty > qty &&
        product.enforceMinimum &&
        cartType !== "SAMPLE" &&
        cartType !== "REPLACEMENT" &&
        cartType !== "DROP SHIP" &&
        cartType !== "RETURN"
      ) {
        qty = parseInt(product.minimumOrderQty);
      }
      item.quantity = qty;

      if (item.qtyPurchased % product.purchaseIncrement) {
        bus.validationErrors.push([
          {
            errorCode: "-1",
            fieldName: "qty",
            message:
              part.id +
              " must be in increments of " +
              product.purchaseIncrement,
          },
        ]);
      }
      if (
        product.purchaseIncrement > 0 &&
        product.enforceMinimum &&
        cartType !== "SAMPLE" &&
        cartType !== "REPLACEMENT" &&
        cartType !== "DROP SHIP" &&
        cartType !== "RETURN"
      ) {
        if (item.qtyPurchased % product.purchaseIncrement) {
          bus.validationErrors.push([
            {
              errorCode: "-1",
              fieldName: "qty",
              message:
                part.id +
                " must be in increments of " +
                product.purchaseIncrement,
            },
          ]);
        }
      }
      if (!item.description) item.description = product.shortDescription;
      if (!item.cartId) item.cartId = cart.id;
      if (!item.productId) item.productId = product.id;
      if (!item.upc) item.upc = product.upcCode;
      item.productId = product.id;
      item.extendedTotal = item.quantity * product.price;
      item.subTotal = item.extendedTotal;
      lines.push(item);
    });
    if (lines.length > 0) {
      return ensureCart().then((c) => {
        lines.forEach((line) => {
          if (!line.cartId) line.cartId = c.cartId || c.id;
          cart.tryLockSku(line.productId);
        });
        return bus
          .send("AddCartItems.json?Profiler=Enabled", { items: lines })
          .then(
            function (response) {
              return response.data;
            },
            (res) => { 
              if (res.data.responseStatus.message.indexOf("Violation of PRIMARY KEY constraint") == -1) {
                modals.alert(res.data.responseStatus.message)
              }
            }
          )
          .finally(() => lines.forEach((l) => cart.unlockSku(l.productId)));
      });
    }
  }

  function addMultiItemOptions(item, product) {
    return orderMultiAddOptions({
      size: "xl",
      cartItem: item,
      product: product,
    }).then((result) => {
      console.debug("result", result);
      $window.location.reload();
    });
  }

  function addMultiItem(criteria, updateItems) {
    return orderMultiAdd({
      criteria,
      updateItems,
    }).then((result) => {
      console.debug("result", result);
      $window.location.reload();
    });
  }

  function addToMultipleOrders(product, updateItems) {
    //console.debug("BL*** got into addMultiOrders");
    return addMultiOrders({
      product,
      updateItems,
    }).then((result) => console.debug("result", result));
  }

  function multiEdit(productIds, updateItems = true) {
    if (productIds) {
      return addMultiItem(
        {
          IdIn: productIds,
        },
        updateItems
      );
    } else {
      return addMultiItem(
        {
          IdIn: cart.items.map((i) => i.productId),
        },
        updateItems
      );
    }
  }
  function openAdvancedCart() {
    return advancedCart({
      size: "xl",
    }).then((result) => {
      console.debug("result", result);
      cart.load(cart.id);
    });
  }

  function manualSplit() {
    return orderManualSplit({
      size: "xl",
      title:
        "Select line items from the below list to transfer to a new order, quote or list",
    }).then((result) => console.debug("result", result));
  }

  function manualCopy() {
    return orderManualCopy({
      size: "xl",
      title: "Copy Order",
      subTitle: "Select line items from the below list to copy to a new order",
    }).then((result) => {
      console.debug("result", result);
    });
  }

  function addItem(item, product, force = false, offerId, silent) {
    let qty = 1;
    cart.canLockSku(product.id);
    if (!productMap[product.id]) {
      productMap[product.id] = product;
    }
    product.cartStatus = "processing";

    if (cart.canEdit === false && !cart.agencyCanEdit) {
      return notify.error(`${cart.id} may not be modified`, {
        title: "Cart not editable",
        ttl: 5000,
      });
    }
    if (cart.type == "Commitment" || cart.type == "Interest") {
      return notify.error(`${cart.id} may not be modified`, {
        title: "Items can't be added to Commitment/Interest order type",
        ttl: 5000,
      });
    }

    if (product.itemType === "Kit" && product.isKitEditable) {
      return orderEditableKit({
        cartItem: item,
        product: product,
      }).then((result) => console.debug("result", result));
    }

    if (
      !force &&
      product.isConfigurable() &&
      !(item.options || []).length &&
      !item.comments
    ) {
      return cartItemQuickViewPrompt({
        cartItem: item,
        add: product.isConfigurable(),
        product,
      }).then((result) => console.debug("result", result));
    }

    if (!force && !product.isConfigurable() && cart.hasItem(product.id)) {
      let existingItem = cart.itemIndex[product.id];
      const exitingItemActions = {
        "Add New Line": {
          icon: "cart-plus",
          body: "Create an additional line to add this item to the current order",
          handler: () => {
            addItem(item, product, true);
            $rootScope.$emit("cart-item-added");
            $rootScope.$broadcast("cart-item-added");
          },
        },
        Edit: {
          icon: "retweet",
          body: "Edit the existing line item",
          handler: () => {
            cart.$itemSearch = product.id;
            $rootScope.$emit("cart-item-added");
            $rootScope.$broadcast("cart-item-added");
            //changeOptions(
            //	Object.assign(existingItem, { qtyPurchased: item.quantity }, item)
            //);
          },
        },
        Cancel: {
          icon: "close",
          body: "Do not add #" + product.id,
          handler: () => {
            $rootScope.$emit("cart-item-added");
            $rootScope.$broadcast("cart-item-added");
            return false;
          },
        },
      };
      if (cartConfig.preventDuplicateSKUs) {
        delete exitingItemActions["Add New Line"];
      }
      if (cartConfig.alwaysAddNewWhenExists) {
        addItem(item, product, true);
        return;
      } else {
        if (cart.config.playErrorSound) cart.playErrorSound();
        return actionList({
          title: `${product.id} already exists on this order`,
          // subTitle: `QTY: ${existingItem.qtyPurchased}`,
          body: `${existingItem.description} is currently on order. 
        Quantity: ${existingItem.qtyPurchased},
         How would you like to proceed?`,
          actions: exitingItemActions,
          size: "md",
        }).then((a) => a.handler());
      }
    }
    if (
      !force &&
      product.openOrder.OrderId &&
      shoppingConfig.notifyItemOnOpenOrder
    ) {
      let openItem = product.openOrder;
      console.debug("openItem", { openItem, item, product, shoppingConfig });
      const openItemActions = {
        "Add New Line": {
          icon: "cart-plus",
          body: "Continue to add this item to the current order",
          handler: () => {
            addItem(item, product, true);
            $rootScope.$emit("cart-item-added");
            $rootScope.$broadcast("cart-item-added");
          },
        },
        Cancel: {
          icon: "close",
          body: "Cancel",
          handler: function () {
            $rootScope.$emit("cart-item-added");
            $rootScope.$broadcast("cart-item-added");
            return;
          },
        },
      };
      if (cart.config.playErrorSound) cart.playErrorSound();
      return actionList({
        title: `${product.id} already on an open order`,
        subTitle: `${openItem.QtyPurchased} @ ${moment
          .utc(openItem.OrderedOn)
          .format("l")}`,
        body: `${product.shortDescription} is currently on an open order. 
        Quantity: ${openItem.QtyPurchased},
         Order Date: ${moment.utc(openItem.OrderedOn).format("l")}.  
         How would you like to proceed?`,
        actions: openItemActions,
        size: "md",
      }).then((a) => a.handler());
    }

    if (
      !force &&
      product.tags &&
      product.tags != undefined &&
      product.tags.AddCartItemMessage
    ) {
      const cartItemActions = {
        "Add Item": {
          icon: "cart-plus",
          body: "Continue to add item " + product.id + " to the current order",
          handler: () => addItem(item, product, true),
        },
        Cancel: {
          icon: "close",
          body: "Cancel",
          handler: function () {
            return;
          },
        },
      };
      if (cart.config.playErrorSound) cart.playErrorSound();
      return actionList({
        //				title: "Item Message",
        title: product.tags.AddCartItemMessage[0],
        actions: cartItemActions,
        size: "md",
      }).then((a) => a.handler());
    }

    // console.warn("addItem", cart.id, cart.vendorId, product.id, product.vendorId, { item, product, force, offerId, silent, cartConfig, cart });
    if (
      !force &&
      (($session.isAgency() && !cartConfig.allowMultipleVendors) ||
        cartConfig.mfgOneVendorPerOrder) &&
      product.vendorId &&
      cart.vendorId &&
      product.vendorId !== cart.vendorId
    ) {
      // console.debug("cartConfig.mfgOneVendorPerOrder", {
      //   cartConfig,
      //   force,
      //   product,
      //   cart,
      // });
      if (cartConfig.mfgOneVendorPerOrder == "Silent") {
        return getOrCreateCartForVendor(
          product.vendorId,
          cart.multiCartId || cart.id,
          cart.status
        ).then((res) => {
          // console.debug("addItem.getOrCreateCartForVendor", {
          //   "cart.id": cart.id,
          //   "cart.vendorId": cart.vendorId,
          //   "product.vendorId": product.vendorId,
          //   "product.id": product.id,
          //   "res.id": res.id,
          //   res,
          //   item
          // });
          cart.id = res.id;
          cart.vendorId = product.vendorId;
          item.cartId = res.id;
          return addItem(item, product, true);
        }).then(() => cart.load(cart.id));
      }
      const newOrderActions = {
        "Add Order": {
          icon: "cart-plus",
          body: "Start new order for vendor " + product.meta.VendorCompanyName,
          handler() {
            getOrCreateCartForVendor(
              product.vendorId,
              cart.multiCartId || cart.id,
              cart.status
            ).then((res) => {
              cart.id = res.id;
              cart.vendorId = product.vendorId;
              item.cartId = res.id;
              return addItem(item, product, true).then(() =>
                cart.load(cart.id)
              );
            });
          },
        },
        Cancel: {
          icon: "close",
          body: "Cancel",
          handler: function () {
            return;
          },
        },
      };
      var bVendorOrderFound = false;
      if (cart.orderCountInSession() > 1) {

        cart.ordersInSession().map((ord) => {
          if (
            ord.vendor &&
            (ord.vendor === product.vendorId || ord.vendor.id === product.vendorId) &&
            ord.customerID === cart.retailerId &&
            ord.status === "Cart"
          ) {
            bVendorOrderFound = true;
            cart.id = ord.id;
            cart.vendorId = product.vendorId;
            item.cartId = ord.id;
            cart.load(cart.id).then(function() {
                return addItem(item, product, false).then(() => {
                  cart.load(cart.id);
                  $state.go('quick-order', {orderId: cart.id, openedit: false})
                });
            });
            // return addItem(item, product, true).then(() => cart.load(cart.id));
          }
        });
      }
      if (!bVendorOrderFound) {
        if (cart.config.playErrorSound) cart.playErrorSound();
        return actionList({
          title: "Vendor Restriction",
          body: `Only one vendor allowed per order`,
          actions: newOrderActions,
          size: "md",
        }).then((a) => a.handler());
      }
      return;
    }

    const cartType = (cart.type || "").toUpperCase();
    if (item.qtyPurchased > qty) {
      qty = parseInt(item.qtyPurchased);
    } else if (item.quantity > qty) {
      qty = parseInt(item.quantity);
    } else if (
      product.minimumOrderQty > qty &&
      cartType !== "SAMPLE" &&
      cartType !== "REPLACEMENT" &&
      cartType !== "DROP SHIP" &&
      cartType !== "RETURN"
    ) {
      qty = parseInt(product.minimumOrderQty);
    }
    //this is to catch any items already added via kit with a different min.
    if (
      !item.canModify &&
      item.isKitComponent &&
      qty < product.minimumOrderQty
    ) {
      qty = parseInt(product.minimumOrderQty);
    }
    item.quantity = item.qtyPurchased = qty;

    if (
      !force &&
      shoppingConfig.notifyQuantity > 0 &&
      item.quantity > shoppingConfig.notifyQuantity
    ) {
      const largeQtyActions = {
        "Add New Line": {
          icon: "cart-plus",
          body: "Continue to add this item to the current order",
          handler: () => addItem(item, product, true),
        },
        Cancel: {
          icon: "close",
          body: "Cancel",
          handler: function () {
            return;
          },
        },
      };

      if (cart.config.playErrorSound) cart.playErrorSound();
      return actionList({
        title: `Large Quantity`,
        body: `Quantity is greater than 999.  
         How would you like to proceed?`,
        actions: largeQtyActions,
        size: "md",
      }).then((a) => a.handler());
    }

    if (
      product.purchaseIncrement > 0 &&
      product.enforceMinimum &&
      cartType !== "SAMPLE" &&
      cartType !== "REPLACEMENT" &&
      cartType !== "DROP SHIP" &&
      cartType !== "RETURN"
    ) {
      if (item.qtyPurchased % product.purchaseIncrement) {
        item.qtyPurchased = product.purchaseIncrement;
        if (cart.config.playErrorSound) cart.playErrorSound();
        return modals
          .alert(
            "Quantity must be in increments of " +
              product.purchaseIncrement +
              " for " +
              product.id
          )
          .result.then(
            () =>
              console.debug("minimumOrderQty:" + product.id, {
                cart,
                product,
              }) ||
              $rootScope.$emit("minimumOrderQty:" + product.id, {
                cart,
                product,
              })
          );
      }
    }

    return ensureCart().then((c) => {
      if (!item.cartId) item.cartId = c.cartId || c.id;
      if (!item.description) item.description = product.shortDescription;
      //if (!item.notes) item.notes = product.longDescription;
      if (!item.cartId) item.cartId = cartId || $cart.id;
      if (!item.productId) item.productId = product.id;
      if (!item.upc) item.upc = product.upcCode;
      if (moment.utc(c.shipOn).isAfter(moment.utc(item.shipOn)))
        item.shipOn = c.shipOn;
      const campaignId = docCookies.getItem("campaignId");
      //console.debug("BL*** retrieving campaignID = " + campaignId);

      let request = /*cart.itemIndex[product.id] =*/ Object.assign(item, {
        productId: product.id,
        position: cart.items.length,
        extendedTotal: item.quantity * product.price,
        offerId,
        isKitComponent: false,
        parentPosition: 0,
        campaignId: campaignId,
      });

      if (item.options && item.options.length) {
        cart.designIndex[item.options[0].valueId] = item;
      }
      cart.tryLockSku(request.productId);
      //cart.items.push(item);
      //cart.itemCount++;
      //cart.qtyPurchased += request.quantity;
      //console.log("cartItemAdding", { item, cart, request, product });
      $rootScope.$emit("cartItemAdding", { item, cart, request, product });
      return bus
        .send(
          `AddCartItem.json?Profiler=${
            $session.debugMode ? "Enabled" : "Disabled"
          }`,
          request
        )
        .then(
          function (response) {
            response.data.origQty = response.data.qtyPurchased;
            cart.items.push(response.data); // immediate UI response
            if (
              response.data.product &&
              response.data.shipOn !== response.data.product.shipOn
            )
              cart.lastShipDate = response.data.shipOn;
            notify.success(
              "Item " + product.shortDescription + " added to cart.  Qty " + item.quantity,
              {
                title: "Cart",
                ttl: 2000,
                disableCountDown: true,
              }
            );

            if (shoppingConfig.useFaceBookPixel) {
              try {
                fbq("track", "AddToCart", {
                  content_ids: [product.id],
                  content_type: "product",
                  value: product.price,
                  currency: "USD",
                });
              } catch (err) {}
            }
            if (
              shoppingConfig.resetOneUpAfterAddingConfigurable &&
              $state.current.name === "shop.product"
            ) {
              $state.transitionTo("shop.product", {
                productId: product.id,
                position: -1,
              });
            }
            //console.info("Offer", silent, offerId);
            if (!silent) {
              if (offerId) {
                //cart.load(request.cartId);
                cart.updateStats(true);
                if (product.isKitExplode || cart.items.length == 1) {
                  cart.load();
                } else {
                  cart.scheduleLoad();
                }
              } else {
                //cart.checkOffers(cart.id, "Add To Cart", product.id);
                cart.updateStats(true);
                if (product.isKitExplode || cart.items.length == 1) {
                  cart.load();
                } else {
                  cart.scheduleLoad();
                }
              }
              $rootScope.$broadcast("cartItemAdded", {
                item,
                cart,
                request,
                response,
                product,
              });
            }
            product.cartStatus = "success";
            return response.data;
          },
          (res) => {
            console.warn("minimumOrderQty:" + product.id, { cart, product });
            product.cartStatus = "failed";
            product.errorMessage = res.data.responseStatus.message;
            $rootScope.$emit("minimumOrderQty:" + product.id, {
              cart,
              product,
            });
            if (!silent) return modals.alert(res.data.responseStatus.message);
          }
        )
        .finally(() => cart.unlockSku(request.productId));
    });
  }

  function renameCart(cartId, currentName) {
    return modals
      .prompt("Edit Your Cart", currentName || cart.cartName, { size: "xs", label: "Change Cart Name" })
      .result.then(function (cartName) {
        let request = {
          id: cartId || cart.id,
          cartName,
        };
        $rootScope.$emit("cartRenaming", { cart, request });
        return bus
          .send("RenameCart.json", request)
          .then(function (response) {
            cart.hydrateSessionOrders();
            if (cart.id === cartId) {
              cart.cartName = cartName;
              $rootScope.$emit("cartRenaming", { cart, request, response });
            }
          })
          .catch(errorToastFactory("cartUpdateFailed", cartId));
      });
  }

  function removeCart(cartId, { reload = false } = {}) {
    return modals
      .confirm("Are you sure?", "Delete Cart")
      .result.then(function () {
        let request = {
          id: cartId || cart.id,
          cartId: cartId || cart.id,
        };
        $rootScope.$emit("cartRemoving", { cart, request });
        return bus
          .send("RemoveCart.json", request)
          .then(function (response) {
            $rootScope.$broadcast("cartRemoved", cart);
            cart.reset();
            if (!$session.isRepOrAbove()) {
              mergeCarts();
            }
            if (reload) {
              $window.location.reload();
            }
          })
          .catch(errorToastFactory("cartUpdateFailed", request));
      });
  }

  function print(cartId) {
    return PrintOrderOptions({
      request: {
        id: cartId || cart.id,
        IncludeImages: false,
        IncludeBarcodes: false,
        OrderBy: "strProductID",
      },
    });
  }

  function multiPrint(cartIds = []) {
    let chain = $q.when(cartIds);
    cartIds.forEach((cartId) => {
      chain = chain.then(() => cart.print(cartId));
    });
    return chain;
  }

  function clearCart(cartId) {
    return modals
      .confirm("Are you sure?", "Empty Cart")
      .result.then(function () {
        let request = {
          id: cartId || cart.id,
          cartId: cartId || cart.id,
        };
        $rootScope.$emit("cartClearing", { cart, request });
        return bus
          .send("EmptyCart.json", request)
          .then(function (response) {
            $rootScope.$broadcast("cartCleared", cart);
            return cart.load(request.cartId);
          })
          .catch(errorToastFactory("cartUpdateFailed", request));
      });
  }

  function quickView(
    cartItem,
    productIds = cart.items.map((i) => i.productId).reverse(),
    others = {}
  ) {
    return cartItemQuickViewPrompt({
      cartItem,
      product: cartItem.product,
      productIds,
      ...others,
    }).then(() => load());
  }

  function editItem(
    cartItem,
    productIds = cart.items.map((i) => i.productId).reverse()
  ) {
    if (cartItem.isKitComponent) return;
    if (!$session.isAuthenticated) return;
    //console.debug("editItem.openConfigurator", cartItem);
    if (cartItem.options.length && !cartConfig.useQuickViewOnEditOptions) {
      return openConfigurator({
        // need to test with JR/HKR
        values: cartItem.options,
        product: cartItem.product,
        cartItem,
      });
    }
    if (
      ($session.salesManagementMode || cartItem.options.length) &&
      !cartConfig.disableQuickView
    ) {
      return quickView(cartItem, productIds);
    }

    return $state.go("shop.product", {
      cartId: cart.id,
      id: cart.id,
      productId: cartItem.productId,
      position: cartItem.position,
    });
  }

  function orderQuestionsPrompt(id, retailerId) {
    return OrderQuestionsPrompt({
      //subTitle: cart.purchaser.id,
      id: id,
      retailerId: retailerId,
    });
  }

  function additionalInfo(cartItem, cartId) {
    return cartItemAdditionalInfoPrompt({
      cartItem,
      product: cartItem.product,
    }).then((cartItem) => {
      changeOptions(cartItem);
      //cart.load(cartId);
    });
  }

  function cartItemShipDate(cartItem, cartId) {
    return cartItemShipDatePrompt({
      cartItem,
      product: cartItem.product,
    }).then((cartItem) => {
      //cartItem.ignorePrice = true;
      //console.info("BL*** cartItem = ", cartItem);
      //changeOptions(cartItem);

      let request = {
        cartId: cartItem.cartId,
        shipOn: cartItem.shipOn,
        positions: Array(1).fill(cartItem.position),
        token: cart.token
      };
      return bus
        .send("UpdateCartItemShipDate.json", request)
        .then((response) => {
          cartItem.$shipOn = response.data.shipOn;
          $rootScope.$emit("cartItemOptionsChanged", {
            cartId,
            cartItem,
            request,
            response,
          });
          //cart.load(cartItem.cartId);
        });

      //cart.load(cartId);
    });
  }

  function zeroPrice(cartItem) {
    if (cartItem.price == 0) {
      cartItem.price = -1;
      cartItem.priceOverride = -1;
    } else {
      cartItem.price = 0;
      cartItem.priceOverride = 0;
    }
    changeOptions(cartItem);
  }

  function priceCalculator(cartItem, cartId) {
    return PriceCalculatorPrompt({
      cartItem,
      product: cartItem.product,
    }).then(() => load());
  }

  function shipDatePrompt(cartItem, cartId) {
    const shipDates = cart.items.map((item) =>
      moment.utc(item.shipOn).format("MM/DD/YYYY")
    );
    const actions = _.uniq(shipDates).map((shipdate) => ({
      title: shipdate,
      key: shipdate,
      icon: "",
      body: "",
    }));
    return actionList({
      title: "Select a ship date...",
      actions,
      size: "sm",
    }).then(function ({ key: shipdate }) {
      changeOptions(Object.assign(cartItem, { shipOn: moment.utc(shipdate) }));
    });
  }

  function selectNotes(params) {
    return cartSelectNotes(params).then(function () {
      return cart.load(cartId);
    });
  }

  function selectLineNotes(li) {
    return cartItemSelectNotes({ item: li }).then(function () {
      return cart.load(cartId);
    });
  }

  function additionalCustomerInfo(customerId) {
    return cartAdditionalCustomerInfo({ customerId }).then(function () {
      return;
    });
  }

  function removeItem(item, cartId) {
    cart.canLockSku(item.productId);
    return modals
      .confirm("Are you sure?", "Delete item #" + item.productId)
      .result.then(
        function () {
          let request = {
            id: cartId || cart.id,
            cartId: cartId || cart.id,
            productId: item.productId,
            position: item.position,
            token: cart.token
          };
          cart.tryLockSku(request.productId);
          const index = cart.items.findIndex(
            (i) =>
              i.productId === item.productId && i.position === item.position
          );
          if (index > -1) {
            delete cart.itemIndex[item.productId];
            cart.items.splice(index, 1);
            cart.itemCount--;
            cart.updateStats(true);
          }
          // console.debug("cartItemRemoving", {
          //   index,
          //   item,
          //   cart,
          //   request,
          // });
          $rootScope.$emit("cartItemRemoving", { item, cart, request });
          return bus
            .send("RemoveCartItem.json", request)
            .then(function (response) {
              delete item.qtyPurchased;
              delete item.qtyOrdered;
              delete item.quantity;
              item.position = -1;
              item.create = true;
              item.qtyPurchased =
                (item.product && item.product.minimumOrderQty) ||
                item.minimumOrderQty ||
                1;

              $rootScope.$broadcast("cartItemRemoved", item, cart);
              if (
                cart.$itemSearch !== "" &&
                cart.$itemSearch === item.productId
              )
                cart.$itemSearch = "";

              $rootScope.$emit("cartItemRemoved", {
                item,
                cart,
                request,
                response,
              });
              cart.updateStats(true);
              //return cart.scheduleLoad(); //TODO: why here and not in addItem? duplicate??
              return item && item.product && item.product.isKitExplode
                ? cart.load(request.cartId)
                : cart.scheduleLoad(request.cartId);
            })
            .catch(errorToastFactory("cartUpdateFailed", request))
            .finally(() => cart.unlockSku(request.productId));
        },
        () => (item.qtyPurchased = item.origQty)
      );
  }

  function registerValidationErrorNotification() {
    $rootScope.$watch("$cart.bus.validationErrors", function (errors) {
      console.warn("$cart.bus.validationErrors", errors);
      angular.forEach(errors, function (g, k) {
        angular.forEach(g, function (er) {
          notify.error(er.message, { title: k, ttl: 5000 });
        });
      });
    });
  }

  function emailCart(cartId, title) {
    return modals.open({
      templateUrl: "email-cart-prompt.html",
      controllerAs: "$ctrl",
      controller: function ($scope, $uibModalInstance, $session) {
        let $ctrl = this;
        let model = ($ctrl.model = {
          id: cartId || cart.id,
          from: utils.validateEmail($session.email) ? $session.email : "",
          to: $session.salesManagementMode ? cart.purchaser.email : "",
          subject: $session.clientName + " product suggestions",
          message: "Here are some product suggestions for you to review",
        });
        let bus = ($ctrl.bus = new ServiceBus());
        $ctrl.title = title || "Email Cart Info...";

        $ctrl.save = $ctrl.submit = function () {
          bus
            .send("EmailCart.json", $ctrl.model)
            .then(function (response) {
              $rootScope.$emit("cartEmailed", $ctrl);
              $uibModalInstance.close($ctrl.model);
            })
            .catch(
              errorToastFactory("cartUpdateFailed.EmailCart", $ctrl.model)
            );
        };
        $ctrl.dismiss = $ctrl.cancel = $uibModalInstance.dismiss;
      },
      size: "md",
    }).result;
  }

  function refreshCart(cartId) {
    let request = {
      cartId: cartId || cart.id,
    };
    return bus
    .send("RefreshCart.json", request)
    .then(function (response) {
      $rootScope.$emit("cartRefreshed", cartId);
      notify.success("Cart refreshed", 
          {
            title: "Cart",
            ttl: 3000,
            disableCountDown: true,
          }
      );
      return cart.load(cartId);
    })
    .catch(
      errorToastFactory("cartUpdateFailed.RefreshCart", cartId)
    );
}

  function shareCart(cartId, title) {
    return modals.open({
      templateUrl: "share-cart-prompt.html",
      controllerAs: "$ctrl",
      controller: function ($scope, $uibModalInstance, $session) {
        let $ctrl = this;
        let model = ($ctrl.model = {
          id: cartId || cart.id,
          from: utils.validateEmail($session.email) ? $session.email : "",
          shareWith: $session.salesManagementMode ? cart.purchaser.email : "",
          // subject: $session.clientName + " cart",
          // message: "A cart has been shared with you",
        });
        let bus = ($ctrl.bus = new ServiceBus());
        $ctrl.title = title || "Share Cart Info...";

        $ctrl.save = $ctrl.submit = function () {
          bus
            .send("ShareCart.json", $ctrl.model)
            .then(function (response) {
              $rootScope.$emit("cartShared", $ctrl);
              $uibModalInstance.close($ctrl.model);
            })
            .catch(
              errorToastFactory("cartUpdateFailed.ShareCart", $ctrl.model)
            );
        };
        $ctrl.dismiss = $ctrl.cancel = $uibModalInstance.dismiss;
      },
      size: "md",
    }).result;
  }

  function showLinesStatus(cartId, status) {
    return modals
      .open({
        templateUrl: "cart-list-popup.html",
        controllerAs: "$ctrl",
        controller($scope, $uibModalInstance, $session, $cart) {
          let $ctrl = this;
          $ctrl.$session = $session;
          $ctrl.$cart = $cart;
          $ctrl.status = status;
          cart.load(cartId, null, { suppressFromSession: true });
          $ctrl.dismiss = $ctrl.cancel = $uibModalInstance.dismiss;
        },
        size: "md",
      })
      .result.finally(() => cart.hydrateSessionOrders());
  }

  function openModifyOrder() {
    return modifyOrder({
      size: "xl",
      title: "Modify Order",
      subTitle: "Submit order change requests",
    }).then((result) => console.debug("result", result));
  }

  function getSeed() {
    return {
      name: cart.purchaser.companyName,
      email: cart.purchaser.email,
      phone: cart.purchaser.phone,
      country: "US",
    };
  }

  function exportQuickReport(reportName) {
    let url =
      cart.$appConfig.resolveServiceUrl(
      "RunReport?reportName=QuickReport&displayName=" +
      reportName +
      "&output=xlsx&QuickReportID=" +
      reportName +
      "&QuickReportName=" +
      reportName +
      "&@strOrderNumber=" +
      cart.id +
      "&expandKits=True");

    return (location.href = url);
  }
  function exportQuickReportImages(reportName) {
    let url =
      cart.$appConfig.resolveServiceUrl(
      "RunReport?reportName=QuickReport&displayName=" +
      reportName +
      "&output=xlsx&QuickReportID=" +
      reportName +
      "&QuickReportName=" +
      reportName +
      "&@strOrderNumber=" +
      cart.id +
      "&expandKits=True&displayImage=True");
    //console.info("url", url);
    return (location.href = url);
  }
  function errorToastFactory(eventName, request) {
    //console.debug("$errorToastFactory", eventName);
    return function (res) {
      console.debug(eventName, {
        request,
        cart,
        res,
        notify,
        rs: res.data.responseStatus,
      });
      return $rootScope.$emit(eventName, { cart, res, request });
      if (!res.data.responseStatus.errors) {
        notify.error(res.data.responseStatus.message, {
          title: res.data.responseStatus.errorCode,
          ttl: 11000,
        });
      } else {
        res.data.responseStatus.errors.forEach((e) =>
          notify.error(e.message, {
            // title: e.errorCode,
            ttl: 11000,
          })
        );
      }
    };
  }
  function showCheckout(cart) {
    if (cart.config.showCheckoutAlways) {
      return false;
    }
    if (cart.sourceId == "Direct") {
      return false;
    } else if (
      (!cart.canEdit && !cart.agencyCanEdit) ||
      (cart.exported && cart.status != "Cart")
    ) {
      return true;
    } else {
      return false;
    }
  }
  function countJsonArray(json) {
    //console.info("json", json);
    if (json != undefined && json != null) {
      var count = Object.keys(json).length;
      return count;
    }
    return 0;
  }
};
